const NEEDS = ["HYDRATION", "BARRIER", "SENSITIVITY", "BALANCE", "CLARITY", "RADIANCE", "TONE", "AGE_SUPPORT", "PROTECT"];
const qs = (id) => QUESTIONS.find((q) => q.id === id);

const QUESTIONS = [
  {
    id: "q1",
    title: "Wat valt je op aan je huid?",
    helper: "Kies alles wat je herkent.",
    type: "multi",
    options: [
      ["dry", "Mijn huid voelt droog of trekkerig"],
      ["shine", "Mijn huid wordt snel glanzend"],
      ["sensitive", "Mijn huid voelt gevoelig of reageert snel"],
      ["redness", "Ik heb last van roodheid"],
      ["dull", "Mijn huid oogt dof of vermoeid"],
      ["blemishes", "Ik heb puistjes, mee-eters of andere onzuiverheden"],
      ["pigment", "Ik zie pigmentvlekjes of een ongelijkmatige teint"],
      ["lines", "Ik zie fijne lijntjes of merk dat mijn huid minder stevig wordt"],
      ["nothing", "Eigenlijk niets specifieks — ik wil mijn huid vooral goed verzorgen"],
      ["unsure", "Ik weet het niet zo goed"],
    ],
  },
  {
    id: "q_change",
    title: "Voelt je huid de laatste tijd anders aan dan normaal?",
    type: "single",
    options: [
      ["same", "Nee, ongeveer hetzelfde"],
      ["drier", "Ja, droger of trekkeriger"],
      ["oilier", "Ja, vetter of glanzender"],
      ["more_sensitive", "Ja, gevoeliger of sneller rood"],
      ["more_blemishes", "Ja, ik heb meer onzuiverheden"],
      ["varies", "Mijn huid wisselt de laatste tijd sterk"],
      ["unsure", "Moeilijk te zeggen"],
    ],
  },
  {
    id: "q_change_context",
    title: "Heb je een idee waardoor dat kan komen?",
    helper: "Kies alles wat van toepassing is.",
    type: "multi",
    when: (a) => !has(a, "q_change", "same"),
    options: [
      ["season", "Verandering van weer of seizoen"],
      ["sun", "Zon, vakantie of veel buiten zijn"],
      ["heating", "Verwarming of airconditioning"],
      ["new_product", "Een nieuw skincareproduct"],
      ["routine_changed", "Mijn routine is veranderd"],
      ["hormones", "Hormonen of cyclus"],
      ["stress", "Stress of vermoeidheid"],
      ["unknown", "Geen idee"],
    ],
  },
  {
    id: "q2",
    title: "Hoe voelt je huid direct na het reinigen?",
    type: "single",
    options: [
      ["comfortable", "Comfortabel en zacht"],
      ["slightly_tight", "Een beetje trekkerig"],
      ["dry_tight", "Droog of strak"],
      ["oily", "Vet of glanzend"],
      ["mixed", "Op sommige plekken droog en op andere glanzend"],
      ["sensitive", "Gevoelig, rood of prikkelend"],
      ["varies", "Dat verschilt"],
      ["no_cleanse", "Ik reinig mijn gezicht niet of nauwelijks"],
    ],
  },
  {
    id: "q2a",
    title: "Waarmee reinig je je huid meestal?",
    type: "single",
    when: (a) => any(a, "q2", ["slightly_tight", "dry_tight", "sensitive"]),
    options: [
      ["oil_balm", "Een reinigingsolie of -balsem"],
      ["cream_milk", "Een crème- of melkcleanser"],
      ["micellar", "Micellair water"],
      ["foam_gel", "Een schuimende cleanser of gel"],
      ["soap", "Zeep of douchegel"],
      ["water", "Alleen water"],
      ["various", "Ik gebruik verschillende producten"],
      ["unknown", "Ik weet niet precies welk type cleanser ik gebruik"],
    ],
  },
  {
    id: "q2b",
    title: "En als je na het reinigen even wacht, hoe voelt je huid dan?",
    type: "single",
    when: (a) => any(a, "q2", ["slightly_tight", "dry_tight", "oily", "mixed", "sensitive"]),
    options: [
      ["comfortable", "Comfortabel"],
      ["still_dry", "Nog steeds droog of trekkerig"],
      ["shiny", "Glanzend"],
      ["shiny_tight", "Glanzend én tegelijkertijd trekkerig"],
      ["mixed", "Op sommige plekken droog en op andere glanzend"],
      ["sensitive", "Gevoelig of onrustig"],
      ["unsure", "Moeilijk te zeggen"],
    ],
  },
  {
    id: "q3",
    title: "Wat valt je gedurende de dag op aan je huid?",
    type: "single",
    options: [
      ["comfortable", "Meestal voelt mijn huid comfortabel"],
      ["drier", "Mijn huid wordt steeds droger of trekkeriger"],
      ["shinier", "Mijn huid wordt steeds glanzender"],
      ["tzone", "Vooral mijn voorhoofd, neus en kin gaan glanzen"],
      ["mixed", "Sommige delen voelen droog, andere worden glanzend"],
      ["sensitive_red", "Mijn huid wordt in de loop van de dag gevoeliger of roder"],
      ["varies", "Het verschilt sterk per dag"],
      ["unsure", "Geen idee, daar let ik eigenlijk niet zo op"],
    ],
  },
  {
    id: "q4",
    title: "Heb je een idee waar je huid op dit moment behoefte aan heeft?",
    type: "multi",
    max: 2,
    options: [
      ["hydration", "Meer hydratatie en comfort"],
      ["calm", "Minder gevoeligheid en onrust"],
      ["glow", "Een frissere, stralendere huid"],
      ["balance", "Minder glans"],
      ["clarity", "Minder onzuiverheden"],
      ["tone", "Een egalere teint"],
      ["age", "Minder zichtbare fijne lijntjes en meer stevigheid"],
      ["barrier", "Een huid die minder droog, trekkerig of kwetsbaar aanvoelt"],
      ["spf", "Goede dagelijkse bescherming tegen de zon"],
      ["simple", "Mijn huid gewoon goed verzorgen, zonder ingewikkelde routine"],
      ["unsure", "Ik weet het niet — daarom doe ik deze Skin Check"],
    ],
  },
  {
    id: "q5",
    title: "Hoe ziet je skincare-routine eruit?",
    type: "single",
    options: [
      ["minimal", "Ik gebruik eigenlijk nauwelijks skincare"],
      ["cleanser_cream", "Cleanser + crème"],
      ["cleanser_serum_cream", "Cleanser + serum + crème"],
      ["many_actives", "Ik gebruik meerdere serums of andere skincareproducten"],
      ["varies", "Mijn routine verschilt nogal"],
      ["unsure_order", "Ik weet niet goed welke producten ik wanneer moet gebruiken"],
    ],
  },
  {
    id: "q6",
    title: "Gebruik je dagelijks SPF op je gezicht?",
    type: "single",
    options: [
      ["daily", "Ja, iedere dag"],
      ["mostly", "Meestal wel"],
      ["sunny", "Alleen als de zon schijnt"],
      ["spring_summer", "Vooral in de lente en zomer"],
      ["rarely", "Zelden"],
      ["no", "Nee"],
    ],
  },
  {
    id: "q6a",
    title: "Hoe gebruik je SPF?",
    helper: "Kies alles wat van toepassing is.",
    type: "multi",
    options: [
      ["morning", "Alleen ’s ochtends"],
      ["reapply", "Ik breng SPF later op de dag opnieuw aan"],
      ["hard", "Ik zou SPF wel willen bijwerken, maar vind dat lastig"],
      ["forget", "Ik denk er meestal niet aan om SPF opnieuw aan te brengen"],
      ["varies", "Dat verschilt"],
    ],
  },
  {
    id: "q6b",
    title: "Wat vind je belangrijk aan een SPF?",
    type: "multi",
    options: [
      ["light", "Een lichte textuur"],
      ["non_sticky", "Geen vettig of plakkerig gevoel"],
      ["glow", "Een mooie glow"],
      ["makeup", "Dat hij goed werkt onder make-up"],
      ["top_up", "Dat ik hem makkelijk opnieuw kan aanbrengen"],
      ["bag", "Dat ik hem makkelijk mee kan nemen"],
      ["few_layers", "Zo min mogelijk verschillende lagen of producten"],
      ["none", "Geen sterke voorkeur"],
    ],
  },
  {
    id: "q6c",
    title: "Hoe gebruik je SPF in je ochtendroutine?",
    type: "single",
    when: (a) => any(a, "q6", ["daily", "mostly"]) || has(a, "q6b", "few_layers"),
    options: [
      ["cream_plus_spf", "Ik gebruik een dagcrème met daaroverheen SPF"],
      ["spf_replaces_cream", "Ik gebruik een SPF die ook als dagcrème bedoeld is"],
      ["only_spf", "Ik gebruik alleen SPF, zonder aparte dagcrème"],
      ["varies", "Dat verschilt"],
      ["unknown", "Ik weet het niet precies"],
    ],
  },
  {
    id: "q_sens_how",
    title: "Waaraan merk je dat je huid gevoelig of onrustig is?",
    helper: "Kies alles wat van toepassing is.",
    type: "multi",
    when: (a) => has(a, "q1", "sensitive") || has(a, "q1", "redness") || has(a, "q4", "calm") || has(a, "q2", "sensitive") || has(a, "q3", "sensitive_red"),
    options: [
      ["reacts", "Mijn huid reageert snel op nieuwe producten"],
      ["stings", "Producten kunnen prikken of branderig aanvoelen"],
      ["itches", "Mijn huid jeukt soms"],
      ["red", "Mijn huid wordt snel rood"],
      ["fragile", "Mijn huid voelt kwetsbaar of geïrriteerd"],
      ["varies", "Het verschilt"],
    ],
  },
  {
    id: "q_sens_freq",
    title: "Hoe vaak heb je daar last van?",
    type: "single",
    when: (a) => has(a, "q1", "sensitive") || has(a, "q1", "redness") || has(a, "q4", "calm") || has(a, "q2", "sensitive") || has(a, "q3", "sensitive_red"),
    options: [
      ["sometimes", "Af en toe"],
      ["weekly", "Een paar keer per week"],
      ["daily", "Bijna dagelijks"],
      ["almost_always", "Vrijwel altijd"],
      ["unsure", "Moeilijk te zeggen"],
    ],
  },
  {
    id: "q_red_duration",
    title: "Trekt de roodheid of irritatie meestal snel weer weg?",
    type: "single",
    when: (a) => has(a, "q1", "sensitive") || has(a, "q1", "redness") || has(a, "q4", "calm") || has(a, "q2", "sensitive") || has(a, "q3", "sensitive_red"),
    options: [
      ["quick", "Ja, meestal vrij snel"],
      ["hours", "Nee, het blijft vaak uren aanwezig"],
      ["constant", "Nee, het is bijna voortdurend aanwezig"],
      ["varies", "Dat verschilt"],
      ["not_applicable", "Niet van toepassing, mijn huid is vooral gevoelig zonder roodheid"],
    ],
  },
  {
    id: "q_blemish_type",
    title: "Wat valt je vooral op aan je onzuiverheden?",
    helper: "Kies alles wat van toepassing is.",
    type: "multi",
    when: (a) => has(a, "q1", "blemishes") || has(a, "q4", "clarity") || has(a, "q_change", "more_blemishes"),
    options: [
      ["occasional", "Af en toe een puistje"],
      ["blackheads", "Mee-eters of verstopte poriën"],
      ["regular", "Regelmatig meerdere puistjes"],
      ["deep", "Diepere of pijnlijke ontstekingen"],
      ["dry_tight", "Onzuiverheden en een droge of trekkerige huid"],
      ["sensitive_red", "Onzuiverheden en een gevoelige of rode huid"],
    ],
  },
  {
    id: "q_blemish_where",
    title: "Waar komen de onzuiverheden vooral voor?",
    type: "single",
    when: (a) => has(a, "q1", "blemishes") || has(a, "q4", "clarity") || has(a, "q_change", "more_blemishes"),
    options: [
      ["tzone", "Voorhoofd, neus en kin"],
      ["cheeks", "Wangen"],
      ["jaw", "Kaaklijn en kin"],
      ["spread", "Verspreid over mijn gezicht"],
      ["varies", "Dat wisselt"],
    ],
  },
  {
    id: "q_blemish_freq",
    title: "Hoe vaak heb je er last van?",
    type: "single",
    when: (a) => (has(a, "q1", "blemishes") || has(a, "q4", "clarity") || has(a, "q_change", "more_blemishes")) && !has(a, "q_blemish_type", "occasional"),
    options: [
      ["sometimes", "Af en toe"],
      ["regular", "Regelmatig"],
      ["constant", "Vrijwel voortdurend"],
      ["periods", "Vooral in bepaalde periodes, bijvoorbeeld rond mijn cyclus"],
      ["varies", "Dat verschilt"],
    ],
  },
  {
    id: "q_pigment_type",
    title: "Wat valt je vooral op aan je teint?",
    type: "single",
    when: (a) => has(a, "q1", "pigment") || has(a, "q4", "tone"),
    options: [
      ["post_blemish", "Donkere vlekjes na puistjes"],
      ["sun_spots", "Zon- of pigmentvlekjes"],
      ["general", "Mijn teint is op sommige plekken wat ongelijk"],
      ["redness", "Roodheid maakt mijn teint ongelijk"],
      ["unsure", "Ik weet niet precies wat het is"],
    ],
  },
  {
    id: "q_pigment_since",
    title: "Is dit iets van de laatste tijd?",
    type: "single",
    when: (a) => has(a, "q1", "pigment") || has(a, "q4", "tone"),
    options: [
      ["recent", "Ja, pas sinds kort"],
      ["longer", "Nee, ik zie het al langere tijd"],
      ["increasing", "Het valt me op dat het geleidelijk meer wordt"],
      ["unknown", "Dat weet ik niet"],
    ],
  },
  {
    id: "q_pigment_spf",
    title: "Gebruik je dagelijks SPF op je gezicht?",
    type: "single",
    when: (a) => (has(a, "q1", "pigment") || has(a, "q4", "tone")) && !a.q6?.length,
    options: [
      ["daily", "Ja, iedere dag"],
      ["mostly", "Meestal wel"],
      ["sunny", "Alleen als de zon schijnt"],
      ["spring_summer", "Vooral in de lente en zomer"],
      ["rarely", "Zelden"],
      ["no", "Nee"],
    ],
  },
  {
    id: "q_age_support",
    title: "Waar zou je graag extra aandacht aan willen geven?",
    helper: "Kies alles wat van toepassing is.",
    type: "multi",
    when: (a) => has(a, "q1", "lines") || has(a, "q4", "age"),
    options: [
      ["lines", "Fijne lijntjes"],
      ["firmness", "Stevigheid en elasticiteit"],
      ["dryness_lines", "Droogtelijntjes"],
      ["dull", "Een doffere of vermoeide uitstraling"],
    ],
  },
  {
    id: "q_eye",
    title: "Wil je ook extra aandacht geven aan de huid rond je ogen?",
    type: "single",
    when: (a) => has(a, "q1", "lines") || has(a, "q4", "age"),
    options: [
      ["yes", "Ja"],
      ["no", "Nee"],
      ["no_preference", "Geen voorkeur"],
    ],
  },
  {
    id: "q_age_skin",
    title: "Wat valt je daarnaast op aan je huid?",
    type: "single",
    when: (a) => has(a, "q1", "lines") || has(a, "q4", "age"),
    options: [
      ["comfortable", "Mijn huid voelt comfortabel"],
      ["dry", "Mijn huid voelt droog of trekkerig"],
      ["sensitive", "Mijn huid voelt gevoelig"],
      ["shiny", "Mijn huid wordt snel glanzend"],
      ["mixed", "Mijn huid is op sommige plekken droog en op andere glanzend"],
      ["varies", "Dat verschilt"],
    ],
  },
  {
    id: "q_actives",
    title: "Gebruik je producten met actieve ingrediënten, zoals retinol of exfoliërende zuren?",
    type: "single",
    when: (a) => has(a, "q1", "lines") || has(a, "q4", "age"),
    options: [
      ["regular", "Ja, regelmatig"],
      ["sometimes", "Soms"],
      ["no", "Nee"],
      ["unknown", "Ik weet niet precies wat actieve ingrediënten zijn"],
    ],
  },
  {
    id: "q_dull_type",
    title: "Wat valt je vooral op aan je huid?",
    helper: "Kies alles wat van toepassing is.",
    type: "multi",
    when: (a) => has(a, "q1", "dull") || has(a, "q4", "glow"),
    options: [
      ["no_glow", "Mijn huid mist glow"],
      ["dry", "Mijn huid voelt ook droog"],
      ["grey", "Mijn teint oogt grauw of vermoeid"],
      ["rough", "Mijn huid voelt ruw of minder glad"],
    ],
  },
  {
    id: "q_dull_sensitive",
    title: "Is je huid daarnaast gevoelig of snel geïrriteerd?",
    type: "single",
    when: (a) => has(a, "q1", "dull") || has(a, "q4", "glow"),
    options: [
      ["yes", "Ja"],
      ["sometimes", "Soms"],
      ["no", "Nee"],
      ["unsure", "Moeilijk te zeggen"],
    ],
  },
];

const PRODUCTS = [
  p("sensilis-never-mist", "Sensilis", "Sensilis Never Mist Me SPF50+ 100 ml", "SPF_REAPPLICATION", "CONDITIONAL", ["PROTECT"], { PROTECT: 3 }, "AS_NEEDED", true, "Sterk bij expliciete moeite met heraanbrengen / over make-up.", ["makkelijk bijwerken", "over make-up"], false, 26),
  p("sensilis-ha-color", "Sensilis", "Sensilis Photocorrection [HA 50+] Color 50ml", "DAILY_SPF", "CONTEXTUAL", ["PROTECT", "HYDRATION"], { PROTECT: 3, HYDRATION: 1 }, "AM", true, "Protect-basis; finish/usecase bepaalt winnaar.", ["verzorgende SPF", "kan lagen beperken"], true, 32),
  p("sensilis-pure", "Sensilis", "Sensilis Photocorrection [Pure 50] SPF50+ 40ml", "DAILY_SPF", "TRUE", ["PROTECT", "BALANCE"], { PROTECT: 3, BALANCE: 1 }, "AM", true, "Protect-basis; finish/usecase bepaalt winnaar.", ["lichte dagelijkse SPF"], false, 28),
  p("sensilis-dpigment", "Sensilis", "Sensilis Photocorrection [D-Pigment 50+] Color Blurring Mousse 40 ml", "DAILY_SPF", "CONTEXTUAL", ["PROTECT", "TONE"], { PROTECT: 3, TONE: 1 }, "AM", true, "Protect-basis; finish/usecase bepaalt winnaar.", ["SPF met teint-context"], true, 34),
  p("sensilis-water-fluid", "Sensilis", "Sensilis Water Fluid Invisible SPF50+ 40 ml", "DAILY_SPF", "TRUE", ["PROTECT", "HYDRATION"], { PROTECT: 3, HYDRATION: 1 }, "AM", true, "Protect-basis; finish/usecase bepaalt winnaar.", ["lichte, verzorgende dagelijkse SPF"], true, 27),
  p("sensilis-oil-control", "Sensilis", "Sensilis Oil Control Dry Touch SPF50+ 40 ml", "DAILY_SPF", "TRUE", ["PROTECT", "BALANCE"], { PROTECT: 3, BALANCE: 2 }, "AM", false, "Protect-basis; finish/usecase bepaalt winnaar.", ["droger aanvoelende finish"], false, 27),
  p("sensilis-barrier", "Sensilis", "Sensilis Skin Rescue [Barrier] 50 ml", "BARRIER_CREAM", "TRUE", ["BARRIER", "SENSITIVITY", "RESTORE"], { BARRIER: 3, SENSITIVITY: 3, HYDRATION: 1 }, "AM_PM", false, "Sterke barrière/gevoeligheidsmatch.", ["comfort en barrièreondersteuning", "rustiger keuze bij gevoeligheid"], true, 35),
  p("sensilis-hydra", "Sensilis", "Sensilis Hydra Essence [Sorbet-Gel] 40 ml", "MOISTURIZER", "TRUE", ["HYDRATION"], { HYDRATION: 3, BARRIER: 1 }, "AM_PM", false, "Textuur en barrièrecontext bepalen ranking.", ["hydratatie en comfort"], true, 30),
  p("sensilis-cool-rescue", "Sensilis", "Sensilis The Cool Rescue 150 ml", "MIST_RESCUE", "CONTEXTUAL", ["COMFORT", "SENSITIVITY", "RESTORE"], { SENSITIVITY: 2, BARRIER: 1 }, "AS_NEEDED", false, "Aanvullende rescue/comfortrol; niet automatisch hoofdproduct.", ["aanvullende comfortstap"], true, 25),
  p("sensilis-serum-sos", "Sensilis", "Sensilis Skin Rescue [Serum SOS] 30 ml", "SERUM", "TRUE", ["SENSITIVITY", "BARRIER", "RESTORE"], { SENSITIVITY: 3, BARRIER: 2 }, "AM_PM", false, "Concurreert alleen met passende serumrol; concrete concern telt mee.", ["serum voor rust en barrièrecontext"], true, 40),
  p("sensilis-calm-balm", "Sensilis", "Sensilis Calm in Balm 50 ml", "CLEANSER", "TRUE", ["CLEANSING", "SENSITIVITY", "COMFORT"], { BARRIER: 2, SENSITIVITY: 2 }, "PM", false, "Kan hoofdmatch zijn bij cleansing mismatch.", ["mildere reinigingsstap"], true, 24),
  p("sensilis-micellar", "Sensilis", "Sensilis Micellar Water [AR] 400 ml", "CLEANSER", "TRUE", ["CLEANSING", "SENSITIVITY", "COMFORT"], { SENSITIVITY: 2, BARRIER: 1 }, "AM_PM", false, "Kan hoofdmatch zijn bij cleansing mismatch.", ["milde reiniging"], true, 19),
  p("sensilis-mousse", "Sensilis", "Sensilis Gentle Cleansing Mousse 200ml", "CLEANSER", "TRUE", ["CLEANSING", "SENSITIVITY", "COMFORT"], { SENSITIVITY: 1, BARRIER: 1 }, "AM_PM", false, "Kan hoofdmatch zijn bij cleansing mismatch.", ["zachte reiniging"], true, 22),
  p("darling-cloud", "DARLING", "DARLING Cloud Drop SPF50 50ml", "DAILY_SPF", "TRUE", ["PROTECT", "HYDRATION"], { PROTECT: 3, HYDRATION: 2, BARRIER: 1 }, "AM", true, "Protect-basis; finish/usecase bepaalt winnaar.", ["ultralicht", "moisturizer + SPF in één", "onder make-up"], true, 38),
  p("cb-sophia", "CATARINA BARBOSA", "CATARINA BARBOSA Sophia - Radiance Face Serum 30 ml", "SERUM", "TRUE", ["TONE", "RADIANCE", "AGE_SUPPORT"], { TONE: 3, RADIANCE: 3, AGE_SUPPORT: 1 }, "AM_PM", false, "Concurreert alleen met passende serumrol; concrete concern telt mee.", ["gericht bij dofheid, pigmentvlekjes en ongelijkmatige teint"], false, 58),
  p("cb-isabel", "CATARINA BARBOSA", "CATARINA BARBOSA Isabel – Gentle Cleansing Oil 100 ml", "CLEANSER", "TRUE", ["CLEANSING", "SENSITIVITY", "COMFORT"], { BARRIER: 2, SENSITIVITY: 1 }, "PM", false, "Kan hoofdmatch zijn bij cleansing mismatch.", ["reinigingsolie als mildere reinigingsstap"], true, 34),
  p("cb-florbela", "CATARINA BARBOSA", "CATARINA BARBOSA Florbela - Enzyme Mask 50 mL", "MASK_TREATMENT", "OPTIONAL", ["RADIANCE", "TEXTURE"], { RADIANCE: 2 }, "AS_NEEDED", false, "Alleen als derde/targeted stap wanneer huidcontext dit toelaat.", ["targeted stap voor glow/texture wanneer de huidcontext dit toelaat"], false, 52),
  p("cb-eunice", "CATARINA BARBOSA", "CATARINA BARBOSA Eunice - Revitalizing Floral Essence 100 ml", "TONER_ESSENCE", "OPTIONAL", ["HYDRATION", "COMFORT"], { HYDRATION: 1, BARRIER: 1 }, "AM_PM", false, "Aanvullende stap; niet automatisch essentieel.", ["aanvullende hydratatie/comfort"], true, 42),
  p("cb-maria", "CATARINA BARBOSA", "CATARINA BARBOSA Maria - Hydrating Face Serum 30 mL", "SERUM", "TRUE", ["HYDRATION", "BARRIER"], { HYDRATION: 3, BARRIER: 2 }, "AM_PM", false, "Concurreert alleen met passende serumrol; concrete concern telt mee.", ["hydraterend serum met barrièrecontext"], true, 54),
  p("cb-amalia", "CATARINA BARBOSA", "CATARINA BARBOSA Amália – Intensive Facial Oil 30 ml", "FACIAL_OIL", "TRUE", ["RESTORE", "NOURISH", "AGE_SUPPORT"], { AGE_SUPPORT: 2, RADIANCE: 1, BARRIER: 1 }, "AM_PM", false, "AM/PM volgens product; PM kan zachte LOLA-tip zijn.", ["extra voeding, veerkracht en avondcomfort"], false, 68),
  p("darling-hair", "DARLING", "DARLING Milky Hair Screen 150ml", "HAIR_PROTECT", "FALSE", [], {}, "AS_NEEDED", false, "Buiten gezichtsskincheck.", [], false, 0),
  p("darling-shield", "DARLING", "DARLING Shield-Me SPF 50 17gr", "DAILY_SPF", "TRUE", ["PROTECT"], { PROTECT: 3 }, "AM", false, "Protect-basis; finish/usecase bepaalt winnaar.", ["makkelijk mee te nemen SPF"], false, 24),
  p("darling-glowy", "DARLING", "DARLING Glowy Screen SPF 50+ 40ml", "DAILY_SPF", "TRUE", ["PROTECT", "RADIANCE"], { PROTECT: 3, RADIANCE: 2 }, "AM", true, "Protect-basis; finish/usecase bepaalt winnaar.", ["mooie glow", "dagelijkse SPF"], false, 36),
  p("darling-after-sun-mist", "DARLING", "DARLING Mist Me After-Sun 150ml", "AFTER_SUN", "CONTEXTUAL", ["RESTORE", "COMFORT"], { BARRIER: 1 }, "AS_NEEDED", false, "Alleen bij expliciete zon-/after-suncontext.", ["alleen bij expliciete zon-/after-suncontext"], true, 22),
  p("darling-mist-spf", "DARLING", "DARLING Mist Me SPF 50 150ml", "SPF_REAPPLICATION", "TRUE", ["PROTECT"], { PROTECT: 3 }, "AS_NEEDED", false, "Protect-basis; finish/usecase bepaalt winnaar.", ["makkelijk gedurende de dag bijwerken"], false, 29),
  p("darling-body-wash", "DARLING", "DARLING Hydrating Body Wash 225ml", "BODY_CLEANSER", "FALSE", [], {}, "AS_NEEDED", false, "Buiten gezichtsskincheck.", [], false, 0),
  p("darling-screen-50", "DARLING", "DARLING Screen-Me Spray SPF 50+ 150ml", "DAILY_SPF", "TRUE", ["PROTECT"], { PROTECT: 3 }, "AM", false, "Protect-basis; finish/usecase bepaalt winnaar.", ["spray SPF"], false, 29),
  p("darling-screen-30", "DARLING", "DARLING Screen-Me Spray SPF 30 150ml", "DAILY_SPF", "TRUE", ["PROTECT"], { PROTECT: 2 }, "AM", false, "Protect-basis; finish/usecase bepaalt winnaar.", ["spray SPF"], false, 27),
  p("darling-protect-50", "DARLING", "DARLING Protect-Me SPF 50 150ml", "DAILY_SPF", "TRUE", ["PROTECT"], { PROTECT: 3 }, "AM", false, "Protect-basis; finish/usecase bepaalt winnaar.", ["dagelijkse SPF"], false, 30),
  p("darling-soothe-after-sun", "DARLING", "DARLING Soothe Me After-Sun 200ml", "AFTER_SUN", "CONTEXTUAL", ["RESTORE", "COMFORT"], { BARRIER: 1 }, "AS_NEEDED", false, "Alleen bij expliciete zon-/after-suncontext.", ["alleen bij expliciete zon-/after-suncontext"], true, 24),
  p("darling-protect-30", "DARLING", "DARLING Protect-Me SPF 30 150ml", "DAILY_SPF", "TRUE", ["PROTECT"], { PROTECT: 2 }, "AM", false, "Protect-basis; finish/usecase bepaalt winnaar.", ["dagelijkse SPF"], false, 28),
  p("darling-tan", "DARLING", "DARLING Boost-Me Tan Activator 150ml", "SUN_CONTEXT", "CONTEXTUAL", [], {}, "AS_NEEDED", false, "Geen standaard gezichtshuidadvies.", [], false, 0),
  p("oden-eye", "ODEN", "ODEN Contour Précieux 6 ml", "EYE_CARE", "CONDITIONAL", ["AGE_SUPPORT", "HYDRATION"], { AGE_SUPPORT: 2, HYDRATION: 1 }, "AM_PM", false, "Alleen als oogcontour expliciet is geselecteerd.", ["oogcontour alleen bij expliciete oogwens"], true, 36),
  p("oden-eglantier", "ODEN", "ODEN Concentré d'Églantier 6 ml", "BOOSTER", "CONDITIONAL", ["AGE_SUPPORT", "RESTORE", "RADIANCE"], { AGE_SUPPORT: 2, RADIANCE: 1 }, "PM", false, "Alleen passend binnen geschikte olieroutine.", ["geconcentreerde booster binnen een geschikte olieroutine"], false, 32),
  p("oden-brume", "ODEN", "ODEN Brume Botanique Rose 50 ml", "TONER_ESSENCE", "OPTIONAL", ["HYDRATION", "COMFORT"], { HYDRATION: 1, BARRIER: 1 }, "AM_PM", false, "Aanvullende stap; niet automatisch essentieel.", ["aanvullende hydratatie/comfort"], true, 28),
  p("oden-eclat", "ODEN", "ODEN Sérum Éclat 30 ml", "SERUM", "TRUE", ["RADIANCE", "TONE"], { RADIANCE: 3, TONE: 2 }, "AM_PM", false, "Concurreert alleen met passende serumrol; concrete concern telt mee.", ["serum voor glow en teint-context"], false, 48),
  p("oden-hydratant", "ODEN", "ODEN Sérum Hydratant 30 ml", "SERUM", "TRUE", ["HYDRATION", "BARRIER"], { HYDRATION: 3, BARRIER: 2 }, "AM_PM", false, "Concurreert alleen met passende serumrol; concrete concern telt mee.", ["hydraterend serum met barrièrecontext"], true, 46),
  p("oden-creme", "ODEN", "ODEN La Crème Hydratante 30 ml", "MOISTURIZER", "TRUE", ["HYDRATION", "COMFORT"], { HYDRATION: 3, BARRIER: 2 }, "AM_PM", false, "Textuur en barrièrecontext bepalen ranking.", ["lichte parfumvrije dagelijkse moisturizer", "comfort bij droogte/trekkerigheid"], true, 38),
  p("oden-huile", "ODEN", "ODEN Huile Vitaminée 15 ml", "FACIAL_OIL", "TRUE", ["RADIANCE", "NOURISH", "RESTORE"], { RADIANCE: 2, AGE_SUPPORT: 1, BARRIER: 1 }, "AM_PM", false, "AM/PM volgens product; PM kan zachte LOLA-tip zijn.", ["voeding en glow; PM kan prettig zijn"], false, 44),
  p("studio-eye", "STUDIO BOTANIC", "STUDIO BOTANIC Eye Cream 15 ml", "EYE_CARE", "CONDITIONAL", ["AGE_SUPPORT", "HYDRATION"], { AGE_SUPPORT: 2, HYDRATION: 1 }, "AM_PM", false, "Alleen als oogcontour expliciet is geselecteerd.", ["oogcontour alleen bij expliciete oogwens"], true, 29),
  p("studio-toner", "STUDIO BOTANIC", "STUDIO BOTANIC Caring Face Toner 100 ml", "TONER_ESSENCE", "OPTIONAL", ["HYDRATION", "COMFORT"], { HYDRATION: 1, BARRIER: 1 }, "AM_PM", false, "Aanvullende stap; niet automatisch essentieel.", ["aanvullende hydratatie/comfort"], true, 21),
  p("studio-oil", "STUDIO BOTANIC", "STUDIO BOTANIC Face Oil 30 ml", "FACIAL_OIL", "TRUE", ["RESTORE", "NOURISH", "AGE_SUPPORT"], { AGE_SUPPORT: 2, BARRIER: 1 }, "AM_PM", false, "AM/PM volgens product; PM kan zachte LOLA-tip zijn.", ["voeding en restore; PM kan prettig zijn"], true, 30),
  p("studio-antioxidant", "STUDIO BOTANIC", "STUDIO BOTANIC Antioxidant Serum 30 ml", "SERUM", "TRUE", ["AGE_SUPPORT", "HYDRATION"], { AGE_SUPPORT: 3, HYDRATION: 1 }, "AM_PM", false, "Concurreert alleen met passende serumrol; concrete concern telt mee.", ["age-support met hydratatiecontext"], false, 31),
  p("studio-cream", "STUDIO BOTANIC", "STUDIO BOTANIC Face Cream 50 ml", "MOISTURIZER", "TRUE", ["HYDRATION", "COMFORT"], { HYDRATION: 2, BARRIER: 1 }, "AM_PM", false, "Textuur en barrièrecontext bepalen ranking.", ["dagelijkse hydratatie en comfort"], true, 28),
  p("studio-cold", "STUDIO BOTANIC", "STUDIO BOTANIC Cold Cream 50 ml", "BARRIER_CREAM", "TRUE", ["BARRIER", "RESTORE", "NOURISH"], { BARRIER: 3, HYDRATION: 1 }, "AM_PM", false, "Rijke barrière/comfortoptie; concurreert o.a. met Skin Rescue Barrier.", ["rijke barrière/comfortoptie"], true, 29),
  p("studio-hydrating-serum", "STUDIO BOTANIC", "STUDIO BOTANIC Hydrating Serum 30 ml", "SERUM", "TRUE", ["HYDRATION", "BARRIER"], { HYDRATION: 3, BARRIER: 2 }, "AM_PM", false, "Concurreert alleen met passende serumrol; concrete concern telt mee.", ["hydraterend serum met barrièrecontext"], true, 29),
  p("studio-face-serum", "STUDIO BOTANIC", "STUDIO BOTANIC Face Serum 30ml", "SERUM", "TRUE", ["HYDRATION", "RESTORE", "AGE_SUPPORT"], { HYDRATION: 2, AGE_SUPPORT: 2, BARRIER: 1 }, "AM_PM", false, "Concurreert alleen met passende serumrol; concrete concern telt mee.", ["hydratatie, restore en age-support context"], true, 30),
];

const RESULT_FRAGMENTS = {
  q1: {
    dry: "je huid droog of trekkerig aanvoelt",
    shine: "je huid snel glanzend wordt",
    sensitive: "je huid gevoelig aanvoelt of snel reageert",
    redness: "je roodheid ervaart",
    dull: "je huid dof of vermoeid oogt",
    blemishes: "je onzuiverheden herkent",
    pigment: "je pigmentvlekjes of een ongelijkmatige teint ziet",
    lines: "je fijne lijntjes ziet of merkt dat je huid minder stevig wordt",
    nothing: "je vooral goed voor je huid wilt zorgen",
    unsure: "je niet precies weet wat je huid nodig heeft",
  },
  q2: {
    comfortable: "je huid na het reinigen comfortabel en zacht aanvoelt",
    slightly_tight: "je huid na het reinigen een beetje trekkerig aanvoelt",
    dry_tight: "je huid na het reinigen droog of strak aanvoelt",
    oily: "je huid na het reinigen vet of glanzend aanvoelt",
    mixed: "je huid na het reinigen op sommige plekken droog en op andere glanzend aanvoelt",
    sensitive: "je huid na het reinigen gevoelig, rood of prikkelend aanvoelt",
    no_cleanse: "je je gezicht eigenlijk niet of nauwelijks reinigt",
  },
  q2a: {
    foam_gel: "je meestal een schuimende cleanser of gel gebruikt",
    soap: "je zeep of douchegel gebruikt",
    oil_balm: "je meestal een reinigingsolie of balsem gebruikt",
    cream_milk: "je meestal een crème- of melkcleanser gebruikt",
    micellar: "je meestal micellair water gebruikt",
    water: "je meestal alleen water gebruikt",
  },
  q2b: {
    comfortable: "je huid een tijdje later comfortabel aanvoelt",
    still_dry: "je huid een tijdje later nog steeds droog of trekkerig aanvoelt",
    shiny: "je huid een tijdje later glanzend wordt",
    shiny_tight: "je huid een tijdje later glanzend én trekkerig aanvoelt",
    mixed: "je huid een tijdje later gemengd aanvoelt",
    sensitive: "je huid een tijdje later gevoelig of onrustig aanvoelt",
  },
  q3: {
    comfortable: "je huid gedurende de dag meestal comfortabel blijft",
    drier: "je huid gedurende de dag droger of trekkeriger wordt",
    shinier: "je huid gedurende de dag glanzender wordt",
    tzone: "vooral je voorhoofd, neus en kin gaan glanzen",
    mixed: "sommige delen droog aanvoelen terwijl andere glanzend worden",
    sensitive_red: "je huid gedurende de dag gevoeliger of roder wordt",
  },
  q4: {
    hydration: "je meer hydratatie en comfort zoekt",
    calm: "je meer rust en minder gevoeligheid zoekt",
    glow: "je een frissere, stralendere uitstraling wilt",
    balance: "je minder glans en meer balans zoekt",
    clarity: "je minder onzuiverheden wilt",
    tone: "je een egalere teint zoekt",
    age: "je fijne lijntjes of verlies van stevigheid wilt ondersteunen",
    barrier: "je je huidbarrière wilt ondersteunen",
    spf: "je goede dagelijkse zonbescherming belangrijk vindt",
    simple: "je je routine graag eenvoudig houdt",
  },
  q5: {
    minimal: "je nu nauwelijks skincare gebruikt",
    cleanser_cream: "je routine nu vooral uit cleanser en crème bestaat",
    cleanser_serum_cream: "je routine nu uit cleanser, serum en crème bestaat",
    many_actives: "je meerdere serums, actives of producten gebruikt",
    varies: "je routine nogal verschilt",
    unsure_order: "je niet goed weet welke producten je wanneer gebruikt",
  },
  q6: {
    daily: "je dagelijks SPF gebruikt",
    mostly: "je meestal SPF gebruikt",
    sunny: "je SPF vooral gebruikt wanneer de zon schijnt",
    spring_summer: "je SPF vooral in lente en zomer gebruikt",
    rarely: "je SPF zelden gebruikt",
    no: "je geen SPF gebruikt",
  },
  q6a: {
    morning: "je SPF alleen 's ochtends aanbrengt",
    reapply: "je SPF later op de dag opnieuw aanbrengt",
    hard: "je SPF later op de dag zou willen bijwerken, maar dat lastig vindt",
    forget: "je SPF meestal vergeet",
  },
  q6b: {
    light: "je een lichte SPF belangrijk vindt",
    non_sticky: "je geen vettig of plakkerig gevoel wilt",
    glow: "je graag een mooie glow wilt",
    makeup: "je SPF goed onder make-up moet werken",
    top_up: "je SPF makkelijk gedurende de dag wilt kunnen bijwerken",
    bag: "je SPF makkelijk in je tas wilt meenemen",
    few_layers: "je zo min mogelijk verschillende lagen wilt",
  },
  q_sens_how: {
    reacts: "je huid snel reageert op nieuwe producten",
    stings: "producten kunnen prikken of branderig aanvoelen",
    itches: "je huid soms jeukt",
    red: "je huid gemakkelijk rood wordt",
    fragile: "je huid kwetsbaar of geïrriteerd aanvoelt",
  },
  q_blemish_type: {
    occasional: "je af en toe een puistje hebt",
    blackheads: "je mee-eters of verstopte poriën herkent",
    regular: "je regelmatig meerdere puistjes hebt",
    deep: "je diepere of pijnlijke ontstekingen ervaart",
    dry_tight: "je onzuiverheden én een droge of trekkerige huid herkent",
    sensitive_red: "je onzuiverheden én een gevoelige of rode huid herkent",
  },
  q_pigment_type: {
    post_blemish: "je donkere vlekjes na puistjes ziet",
    sun_spots: "je zon- of pigmentvlekjes ziet",
    general: "je algemene verkleuring of ongelijkheid ziet",
    redness: "roodheid je teint ongelijk maakt",
  },
  q_pigment_since: {
    recent: "de teintverandering recent is ontstaan",
    longer: "de pigment- of teintvraag al langere tijd speelt",
    increasing: "de pigment- of teintvraag geleidelijk meer wordt",
    unknown: "je niet precies weet hoe lang de teintverandering speelt",
  },
  q_age_support: {
    lines: "je fijne lijntjes wilt ondersteunen",
    firmness: "je stevigheid of elasticiteit wilt ondersteunen",
    dryness_lines: "je droogtelijntjes herkent",
    dull: "je huid ook doffer of vermoeider oogt",
  },
  q_eye: {
    yes: "je extra aandacht wilt voor de huid rond je ogen",
  },
  q_age_skin: {
    dry: "je huid daarnaast droog of trekkerig aanvoelt",
    sensitive: "je huid daarnaast gevoelig aanvoelt",
    shiny: "je huid daarnaast glanzend wordt",
    mixed: "je huid daarnaast gemengd aanvoelt",
  },
  q_actives: {
    regular: "je regelmatig actieve ingrediënten zoals retinoïden of exfoliërende zuren gebruikt",
    sometimes: "je soms actieve ingrediënten zoals retinoïden of exfoliërende zuren gebruikt",
    unknown: "je niet precies weet of je actieve ingrediënten gebruikt",
  },
  q_dull_type: {
    no_glow: "je huid glow mist",
    dry: "je huid ook droog aanvoelt",
    grey: "je teint grauw of vermoeid oogt",
    rough: "je huid ruw of minder glad aanvoelt",
  },
};

const PRODUCT_CUSTOMER_REASONS = {
  "sensilis-never-mist": "dit formaat bedoeld is om SPF gedurende de dag makkelijker bij te werken.",
  "sensilis-ha-color": "een verzorgende SPF die kan helpen om je ochtendroutine eenvoudiger te houden.",
  "sensilis-pure": "een lichte dagelijkse SPF voor consequente dagelijkse bescherming.",
  "sensilis-dpigment": "een dagelijkse SPF die ook aansluit wanneer een egalere teint belangrijk voor je is.",
  "sensilis-water-fluid": "een lichte, verzorgende dagelijkse SPF die prettig past in een eenvoudige ochtendroutine.",
  "sensilis-oil-control": "de droger aanvoelende finish kan passen wanneer glans duidelijk meespeelt.",
  "sensilis-barrier": "het comfort en ondersteuning van de huidbarrière biedt wanneer je huid gevoelig of onrustig aanvoelt.",
  "sensilis-hydra": "het gericht is op hydratatie en comfort.",
  "sensilis-cool-rescue": "het als aanvullende comfortstap kan passen wanneer je huid gevoelig of onrustig aanvoelt.",
  "sensilis-serum-sos": "deze formule gericht is op rust en ondersteuning wanneer je huid snel reageert of kwetsbaar aanvoelt.",
  "sensilis-calm-balm": "deze reiniging milder aansluit wanneer je huid na het reinigen trekkerig of gevoelig aanvoelt.",
  "sensilis-micellar": "deze reiniging mild blijft wanneer comfort belangrijk is.",
  "sensilis-mousse": "deze reiniging zacht aansluit wanneer comfort belangrijk is.",
  "darling-cloud": "het SPF en verzorging combineert in één lichte ochtendstap.",
  "cb-sophia": "het gericht is op uitstraling, pigmentvlekjes en een ongelijkmatige teint.",
  "cb-isabel": "deze reinigingsolie een mildere stap kan zijn wanneer reinigen je huid uit balans brengt.",
  "cb-florbela": "deze gerichte extra stap past wanneer glow of huidtextuur zelfstandig naar voren komt.",
  "cb-eunice": "deze stap extra hydratatie en comfort kan bieden wanneer je huid daar duidelijk om vraagt.",
  "cb-maria": "het een hydraterend serum is dat ook past bij behoefte aan barrièreondersteuning.",
  "cb-amalia": "deze olie extra voeding, veerkracht en comfort kan geven wanneer je huid daar duidelijk om vraagt.",
  "darling-shield": "het een compact SPF-formaat is dat makkelijk mee kan.",
  "darling-glowy": "een dagelijkse SPF met een mooie, glowy finish.",
  "darling-mist-spf": "het een SPF-formaat is dat bijwerken gedurende de dag makkelijker maakt.",
  "darling-screen-50": "het een spray-SPF is voor dagelijkse bescherming.",
  "darling-screen-30": "het een spray-SPF is voor dagelijkse bescherming.",
  "darling-protect-50": "het een dagelijkse SPF is.",
  "darling-protect-30": "het een dagelijkse SPF is.",
  "oden-eye": "deze verzorging aansluit op je wens om de huid rond je ogen extra aandacht te geven.",
  "oden-eglantier": "het past binnen een geschikte olieroutine of bewuste specialistische stap.",
  "oden-brume": "deze stap extra hydratatie en comfort kan bieden wanneer je huid daar duidelijk om vraagt.",
  "oden-eclat": "deze formule aansluit bij je wens voor meer glow en een egalere teint.",
  "oden-hydratant": "het een hydraterend serum is dat ook past bij behoefte aan barrièreondersteuning.",
  "oden-creme": "het een lichte, parfumvrije crème is voor dagelijkse hydratatie en comfort.",
  "oden-huile": "deze olie voeding en glow kan toevoegen, bij voorkeur als prettige avondstap.",
  "studio-eye": "deze oogcrème aansluit op je wens om de huid rond je ogen extra aandacht te geven.",
  "studio-toner": "deze stap extra hydratatie en comfort kan bieden wanneer je huid daar duidelijk om vraagt.",
  "studio-oil": "deze olie kan passen wanneer je huid extra voeding en comfort vraagt.",
  "studio-antioxidant": "deze formule past bij ondersteuning van fijne lijntjes en hydratatie zonder je routine onnodig zwaar te maken.",
  "studio-cream": "het een dagelijkse crème is voor hydratatie en comfort.",
  "studio-cold": "het een rijkere crème is voor comfort en ondersteuning van de huidbarrière.",
  "studio-hydrating-serum": "het een hydraterend serum is dat ook ondersteuning biedt aan de huidbarrière.",
  "studio-face-serum": "het als serum hydratatie, comfort en ondersteuning bij fijne lijntjes kan combineren.",
};

const PRODUCT_CARD_REASONS = {
  "sensilis-barrier": "Deze moisturizer geeft een gevoelige, onrustige huid comfort en helpt de huidbarrière te ondersteunen.",
  "sensilis-serum-sos": "Dit serum geeft een extra kalmerende verzorgingsstap wanneer je huid snel reageert of kwetsbaar aanvoelt.",
  "sensilis-hydra": "Een hydraterende moisturizer voor dagelijks comfort wanneer je huid extra vocht nodig heeft.",
  "sensilis-calm-balm": "Deze cleanser is een mildere reinigingsstap wanneer je huid na het reinigen trekkerig of gevoelig aanvoelt.",
  "sensilis-micellar": "Deze cleanser houdt de reiniging mild wanneer comfort belangrijk is.",
  "sensilis-mousse": "Deze zachte cleanser past wanneer je huid behoefte heeft aan een milde reinigingsstap.",
  "cb-sophia": "Dit serum is gericht op een doffe of ongelijkmatige teint en helpt je huid meer glow te geven.",
  "cb-isabel": "Deze reinigingsolie is een mildere stap wanneer reinigen je huid snel uit balans brengt.",
  "cb-florbela": "Dit masker is een gerichte extra stap wanneer glow of huidtextuur duidelijk naar voren komt.",
  "cb-eunice": "Deze essence voegt een lichte extra laag hydratatie en comfort toe.",
  "cb-maria": "Dit hydraterende serum geeft je huid vocht en ondersteunt tegelijk het comfort van de huidbarrière.",
  "cb-amalia": "Deze olie geeft extra voeding en comfort wanneer je huid daar duidelijk om vraagt.",
  "oden-eye": "Een verzorgende oogstap voor de huid rond je ogen, precies waar je graag wat extra aandacht aan wilt geven.",
  "oden-eglantier": "Deze geconcentreerde booster past alleen als bewuste, specialistische stap binnen een geschikte routine.",
  "oden-brume": "Deze mist voegt een lichte extra laag hydratatie en comfort toe.",
  "oden-eclat": "Dit serum is gericht op een doffe of ongelijkmatige teint en helpt je huid meer glow te geven.",
  "oden-hydratant": "Dit is de hydraterende serumstap: licht onder je crème en gericht op vocht en comfort.",
  "oden-creme": "Deze moisturizer volgt op je serum en helpt dagelijkse hydratatie en comfort vast te houden.",
  "oden-huile": "Deze olie voegt voeding en glow toe als latere verzorgende stap.",
  "studio-eye": "Een verzorgende oogcrème voor de huid rond je ogen, precies waar je graag wat extra aandacht aan wilt geven.",
  "studio-toner": "Deze toner voegt een lichte extra laag hydratatie en comfort toe.",
  "studio-oil": "Deze olie geeft extra voeding en comfort als latere verzorgende stap.",
  "studio-antioxidant": "Dit serum ondersteunt fijne lijntjes en geeft tegelijk een lichte hydratatiestap.",
  "studio-cream": "Deze moisturizer geeft dagelijkse hydratatie en comfort.",
  "studio-cold": "Deze rijkere moisturizer geeft comfort wanneer je huid droog, trekkerig of kwetsbaar aanvoelt.",
  "studio-hydrating-serum": "Dit hydraterende serum geeft je huid vocht en ondersteunt tegelijk het comfort van de huidbarrière.",
  "studio-face-serum": "Dit serum combineert hydratatie, comfort en ondersteuning bij fijne lijntjes in één stap.",
};

const ANSWER_NEED_HINTS = {
  q1: {
    dry: ["HYDRATION", "BARRIER"],
    shine: ["BALANCE"],
    sensitive: ["SENSITIVITY", "BARRIER"],
    redness: ["SENSITIVITY"],
    dull: ["RADIANCE"],
    blemishes: ["CLARITY"],
    pigment: ["TONE"],
    lines: ["AGE_SUPPORT"],
  },
  q2: {
    slightly_tight: ["HYDRATION", "BARRIER"],
    dry_tight: ["HYDRATION", "BARRIER"],
    oily: ["BALANCE"],
    mixed: ["HYDRATION", "BALANCE"],
    sensitive: ["SENSITIVITY", "BARRIER"],
  },
  q2b: {
    still_dry: ["HYDRATION", "BARRIER"],
    shiny: ["BALANCE"],
    shiny_tight: ["HYDRATION", "BALANCE"],
    mixed: ["HYDRATION", "BALANCE"],
    sensitive: ["SENSITIVITY", "BARRIER"],
  },
  q3: {
    drier: ["HYDRATION", "BARRIER"],
    shinier: ["BALANCE"],
    tzone: ["BALANCE"],
    mixed: ["HYDRATION", "BALANCE"],
    sensitive_red: ["SENSITIVITY", "BARRIER"],
  },
  q4: {
    hydration: ["HYDRATION", "BARRIER"],
    calm: ["SENSITIVITY", "BARRIER"],
    glow: ["RADIANCE"],
    balance: ["BALANCE"],
    clarity: ["CLARITY"],
    tone: ["TONE"],
    age: ["AGE_SUPPORT"],
    barrier: ["BARRIER"],
  },
  q_sens_how: {
    reacts: ["SENSITIVITY"],
    stings: ["SENSITIVITY"],
    itches: ["SENSITIVITY"],
    red: ["SENSITIVITY"],
    fragile: ["SENSITIVITY", "BARRIER"],
  },
  q_blemish_type: {
    occasional: ["CLARITY"],
    blackheads: ["CLARITY"],
    regular: ["CLARITY"],
    deep: ["CLARITY"],
    dry_tight: ["CLARITY", "HYDRATION"],
    sensitive_red: ["CLARITY", "SENSITIVITY"],
  },
  q_pigment_type: {
    post_blemish: ["TONE", "CLARITY"],
    sun_spots: ["TONE"],
    general: ["TONE"],
    redness: ["SENSITIVITY"],
  },
  q_age_support: {
    lines: ["AGE_SUPPORT"],
    firmness: ["AGE_SUPPORT"],
    dryness_lines: ["HYDRATION", "AGE_SUPPORT"],
    dull: ["RADIANCE", "AGE_SUPPORT"],
  },
  q_eye: {
    yes: ["AGE_SUPPORT"],
  },
  q_age_skin: {
    dry: ["HYDRATION"],
    sensitive: ["SENSITIVITY"],
    shiny: ["BALANCE"],
    mixed: ["HYDRATION", "BALANCE"],
  },
  q_actives: {
    regular: [],
    sometimes: [],
    unknown: [],
  },
  q_dull_type: {
    no_glow: ["RADIANCE"],
    dry: ["HYDRATION", "RADIANCE"],
    grey: ["RADIANCE"],
    rough: ["RADIANCE"],
  },
};

let state = { answers: {}, step: "landing", index: 0, debug: null, testResults: null };

function isDebugMode() {
  return typeof location !== "undefined" && new URLSearchParams(location.search).get("debug") === "1";
}

function p(id, brand, title, role, eligibility, pillars, needs, useContext, canReplace, note, why, sensitivityFit, price) {
  return {
    product_id: id,
    shopify_id: id,
    status: "ACTIVE",
    brand,
    title,
    display_title: displayProductTitle(title),
    url: "#",
    product_role: role,
    hpr_pillars: pillars,
    primary_needs: needs,
    secondary_needs: {},
    eligibility,
    texture: "",
    finish: "",
    fragrance: "",
    sensitivity_fit: sensitivityFit ? "GOOD" : "NORMAL",
    actives: [],
    cautions: [],
    not_first_choice_when: [],
    routine_position: role.includes("SPF") ? "protect" : role.toLowerCase(),
    use_context: useContext,
    can_replace_step: canReplace,
    routine_complexity: role === "TONER_ESSENCE" || role === "MASK_TREATMENT" || role === "BOOSTER" ? "HIGH" : "MEDIUM",
    multifunctionality: canReplace ? 2 : 0,
    price,
    why_blocks: why,
    lola_usage_tip: note,
    image_url: "",
    image_alt: `${displayProductTitle(title)} packshot`,
    inventory_status: "IN_STOCK",
  };
}

function readJsonScript(id) {
  const node = typeof document !== "undefined" ? document.getElementById(id) : null;
  if (!node?.textContent) return {};
  try {
    return JSON.parse(node.textContent);
  } catch (error) {
    console.warn(`LOLA Skin Check could not parse ${id}`, error);
    return {};
  }
}

function skinCheckConfig() {
  return readJsonScript("lola-skin-check-config");
}

function skinCheckAsset(name, fallback) {
  return skinCheckConfig().assets?.[name] || fallback;
}

function enrichProductsWithShopifyData() {
  const productsById = readJsonScript("lola-skin-check-product-data");
  PRODUCTS.forEach((product) => {
    const data = productsById[product.product_id];
    if (!data) return;
    product.shopify_id = data.shopify_id || product.shopify_id;
    product.url = data.url || product.url;
    product.image_url = data.image_url || product.image_url;
    product.image_alt = data.image_alt || product.image_alt;
    if (data.available === true) product.inventory_status = "IN_STOCK";
    if (data.available === false) product.inventory_status = "OUT_OF_STOCK";
  });
}

function has(a, q, id) {
  return (a[q] || []).includes(id);
}

function any(a, q, ids) {
  return ids.some((id) => has(a, q, id));
}

function getVisibleQuestions(answers = state.answers) {
  return QUESTIONS.filter((q) => !q.when || q.when(answers));
}

function visibleQuestionIds(answers) {
  return QUESTIONS.filter((q) => !q.when || q.when(answers)).map((q) => q.id);
}

function cleanAnswers(answers) {
  const allowed = new Set(visibleQuestionIds(answers));
  return Object.fromEntries(Object.entries(answers).filter(([id]) => allowed.has(id)));
}

function deriveCanonicalFacts(answers) {
  const facts = {
    blemish_frequency: null,
    blemish_location: null,
    spf_frequency: null,
    spf_application: null,
    spf_reapplication_need: null,
    spf_preferences: [],
  };

  if (has(answers, "q_blemish_type", "occasional")) facts.blemish_frequency = "occasional";
  if (has(answers, "q_blemish_freq", "sometimes")) facts.blemish_frequency = "occasional";
  if (has(answers, "q_blemish_freq", "regular")) facts.blemish_frequency = "regular";
  if (has(answers, "q_blemish_freq", "constant")) facts.blemish_frequency = "constant";
  if (has(answers, "q_blemish_freq", "periods")) facts.blemish_frequency = "periodic";
  if (answers.q_blemish_where?.length) facts.blemish_location = answers.q_blemish_where[0];

  if (answers.q6?.length) facts.spf_frequency = answers.q6[0];
  if (!facts.spf_frequency && answers.q_pigment_spf?.length) {
    facts.spf_frequency = ({ daily: "daily", mostly: "mostly", sunny: "sunny", spring_summer: "spring_summer", rarely: "rarely", no: "no" })[answers.q_pigment_spf[0]] || null;
  }
  if (answers.q6a?.length) facts.spf_application = answers.q6a[0];
  facts.spf_preferences = answers.q6b || [];
  if (has(answers, "q6a", "forget")) {
    facts.spf_reapplication_need = "reminder";
  } else if (has(answers, "q6a", "hard") || has(answers, "q6b", "top_up") || has(answers, "q6b", "bag")) {
    facts.spf_reapplication_need = "explicit";
  } else if (has(answers, "q6a", "reapply")) {
    facts.spf_reapplication_need = "already_reapplying";
  } else if (has(answers, "q6a", "varies")) {
    facts.spf_reapplication_need = "varies";
  }

  return facts;
}

function add(scores, need, amount, source, events) {
  scores[need] += amount;
  events.push({ need, amount, source });
}

function assess(answers) {
  answers = cleanAnswers(answers);
  const canonical_facts = deriveCanonicalFacts(answers);
  const raw = Object.fromEntries(NEEDS.map((n) => [n, 0]));
  const scores = { ...raw };
  const events = [];
  const patterns = [];
  const user_goal = [];
  const safety_flags = [];
  const routine_context = {};
  const spf_context = {};
  const change_context = {};

  if (has(answers, "q1", "dry")) { add(raw, "HYDRATION", 2, "Q1 droog/trekkerig", events); add(raw, "BARRIER", 1, "Q1 droog/trekkerig", events); }
  if (has(answers, "q1", "shine")) add(raw, "BALANCE", 2, "Q1 snel glanzend", events);
  if (has(answers, "q1", "sensitive")) { add(raw, "SENSITIVITY", 2, "Q1 gevoelig/reageert snel", events); add(raw, "BARRIER", 1, "Q1 gevoelig/reageert snel", events); }
  if (has(answers, "q1", "redness")) add(raw, "SENSITIVITY", 2, "Q1 roodheid", events);
  if (has(answers, "q1", "dull")) add(raw, "RADIANCE", 2, "Q1 dof/vermoeid", events);
  if (has(answers, "q1", "blemishes")) add(raw, "CLARITY", 2, "Q1 onzuiverheden", events);
  if (has(answers, "q1", "pigment")) add(raw, "TONE", 2, "Q1 pigment/ongelijke teint", events);
  if (has(answers, "q1", "lines")) add(raw, "AGE_SUPPORT", 2, "Q1 fijne lijntjes/minder stevig", events);

  const q2Map = { slightly_tight: [["HYDRATION", 1], ["BARRIER", 1]], dry_tight: [["HYDRATION", 2], ["BARRIER", 1]], oily: [["BALANCE", 1]], mixed: [["HYDRATION", 1], ["BALANCE", 1]], sensitive: [["SENSITIVITY", 2], ["BARRIER", 1]] };
  applyMap(raw, q2Map, answers.q2, "Q2", events);
  const q2bMap = { still_dry: [["HYDRATION", 2], ["BARRIER", 1]], shiny: [["BALANCE", 1]], shiny_tight: [["HYDRATION", 2], ["BALANCE", 1]], mixed: [["HYDRATION", 1], ["BALANCE", 1]], sensitive: [["SENSITIVITY", 2], ["BARRIER", 1]] };
  applyMap(raw, q2bMap, answers.q2b, "Q2B", events);
  if (has(answers, "q2b", "comfortable") && any(answers, "q2", ["slightly_tight", "dry_tight"])) add(raw, "HYDRATION", -1, "Q2B later comfortabel", events);

  const q3Map = { drier: [["HYDRATION", 2], ["BARRIER", 1]], shinier: [["BALANCE", 2]], tzone: [["BALANCE", 1]], mixed: [["HYDRATION", 1], ["BALANCE", 1]], sensitive_red: [["SENSITIVITY", 2], ["BARRIER", 1]] };
  applyMap(raw, q3Map, answers.q3, "Q3", events);

  const q4Map = { hydration: [["HYDRATION", 2], ["BARRIER", 1]], calm: [["SENSITIVITY", 2], ["BARRIER", 1]], glow: [["RADIANCE", 2]], balance: [["BALANCE", 2]], clarity: [["CLARITY", 2]], tone: [["TONE", 2]], age: [["AGE_SUPPORT", 2]], barrier: [["BARRIER", 2]], spf: [["PROTECT", 3]] };
  (answers.q4 || []).forEach((id) => {
    if (q4Map[id]) q4Map[id].forEach(([need, amount]) => add(raw, need, amount, `Q4 ${label("q4", id)}`, events));
    if (id !== "unsure") user_goal.push(id);
  });
  const simplicity = has(answers, "q4", "simple");
  if (has(answers, "q5", "many_actives")) {
    routine_context.active_user = true;
    routine_context.effect = "Gebruikt als routine/contextsignaal; extra actives worden terughoudender beoordeeld.";
  }
  if (any(answers, "q_actives", ["regular", "sometimes", "unknown"])) {
    routine_context.active_ingredients = answers.q_actives[0];
    routine_context.active_ingredients_effect = "Gebruikt als contextsignaal; dit stapelt niet automatisch extra actieve producten.";
  }

  const qSens = { reacts: 1, stings: 2, itches: 1, red: 1, fragile: 2 };
  (answers.q_sens_how || []).forEach((id) => qSens[id] && add(raw, "SENSITIVITY", qSens[id], `Gevoeligheid: ${label("q_sens_how", id)}`, events));
  if (has(answers, "q_sens_freq", "weekly")) add(raw, "SENSITIVITY", 1, "Gevoeligheid paar keer per week", events);
  if (has(answers, "q_sens_freq", "daily")) add(raw, "SENSITIVITY", 2, "Gevoeligheid bijna dagelijks", events);
  if (has(answers, "q_sens_freq", "almost_always")) add(raw, "SENSITIVITY", 3, "Gevoeligheid vrijwel altijd", events);
  if (has(answers, "q_red_duration", "hours")) safety_flags.push("CAUTION_LOW");
  if (has(answers, "q_red_duration", "constant")) safety_flags.push("MEDICAL_CAUTION");

  if (canonical_facts.blemish_frequency === "occasional") add(raw, "CLARITY", 1, "Af en toe een puistje", events);
  if (has(answers, "q_blemish_type", "blackheads")) add(raw, "CLARITY", 2, "Mee-eters/verstopte poriën", events);
  if (has(answers, "q_blemish_type", "regular")) add(raw, "CLARITY", 2, "Regelmatig meerdere puistjes", events);
  if (has(answers, "q_blemish_type", "deep")) safety_flags.push("MEDICAL_CAUTION");
  if (has(answers, "q_blemish_type", "dry_tight")) add(raw, "HYDRATION", 1, "Onzuiverheden én droog/trekkerig", events);
  if (has(answers, "q_blemish_type", "sensitive_red")) add(raw, "SENSITIVITY", 1, "Onzuiverheden én gevoelig/rood", events);

  if (has(answers, "q_pigment_type", "post_blemish")) { add(raw, "TONE", 2, "Donkere vlekjes na puistjes", events); add(raw, "CLARITY", 1, "Post-blemish context", events); }
  if (has(answers, "q_pigment_type", "sun_spots")) add(raw, "TONE", 2, "Zon-/pigmentvlekjes", events);
  if (has(answers, "q_pigment_type", "general")) add(raw, "TONE", 1, "Algemene verkleuring/ongelijkheid", events);
  if (has(answers, "q_pigment_type", "redness")) add(raw, "SENSITIVITY", 1, "Roodheid maakt teint ongelijk", events);

  if (has(answers, "q_age_support", "lines")) add(raw, "AGE_SUPPORT", 2, "Fijne lijntjes", events);
  if (has(answers, "q_age_support", "firmness")) add(raw, "AGE_SUPPORT", 2, "Stevigheid/elasticiteit", events);
  if (has(answers, "q_age_support", "dryness_lines")) { add(raw, "HYDRATION", 2, "Droogtelijntjes", events); add(raw, "AGE_SUPPORT", 1, "Droogtelijntjes", events); }
  if (has(answers, "q_age_support", "dull")) add(raw, "RADIANCE", 1, "Doffere/vermoeide uitstraling bij age-support", events);
  if (has(answers, "q_age_skin", "dry")) add(raw, "HYDRATION", 1, "Age-context: droog/trekkerig", events);
  if (has(answers, "q_age_skin", "sensitive")) add(raw, "SENSITIVITY", 1, "Age-context: gevoelig", events);
  if (has(answers, "q_dull_type", "no_glow")) add(raw, "RADIANCE", 2, "Mist glow", events);
  if (has(answers, "q_dull_type", "dry")) add(raw, "HYDRATION", 1, "Dof en droog", events);
  if (has(answers, "q_dull_type", "grey")) add(raw, "RADIANCE", 1, "Grauw/vermoeid", events);
  if (has(answers, "q_dull_type", "rough")) add(raw, "RADIANCE", 1, "Ruw/minder glad", events);
  if (has(answers, "q_dull_sensitive", "yes")) add(raw, "SENSITIVITY", 1, "Dof + gevoelig", events);

  Object.assign(scores, raw);
  if (any(answers, "q2", ["slightly_tight", "dry_tight"]) && has(answers, "q2b", "comfortable") && has(answers, "q3", "comfortable")) {
    scores.HYDRATION = Math.max(0, scores.HYDRATION - 2);
    patterns.push("cleansing_mismatch");
  }
  if (any(answers, "q2", ["slightly_tight", "dry_tight"]) && has(answers, "q2b", "still_dry") && has(answers, "q3", "drier")) patterns.push("persistent_dehydration");
  if ((any(answers, "q2", ["slightly_tight", "dry_tight"]) || any(answers, "q2b", ["shiny_tight", "mixed"])) && any(answers, "q3", ["shinier", "tzone", "mixed"])) patterns.push("dehydrated_shine");
  if (has(answers, "q3", "mixed") || (has(answers, "q3", "tzone") && any(answers, "q2b", ["still_dry", "mixed"]))) patterns.push("mixed_need");
  if ((has(answers, "q_sens_how", "stings") || has(answers, "q1", "redness")) && (scores.HYDRATION > 0 || scores.BARRIER > 0)) patterns.push("reactive_barrier_pressure");
  if (has(answers, "q5", "many_actives") || any(answers, "q_actives", ["regular", "sometimes", "unknown"])) patterns.push("active_routine_context");
  if (has(answers, "q5", "many_actives") && (scores.SENSITIVITY >= 3 || patterns.includes("reactive_barrier_pressure"))) patterns.push("simplicity_over_more");
  if ((scores.TONE >= 2 || scores.AGE_SUPPORT >= 3) && insufficientSpf(answers)) patterns.push("tone_or_age_missing_spf");
  if (scores.AGE_SUPPORT >= 2 && scores.HYDRATION >= 3) patterns.push("age_support_dryness_lines");

  if (has(answers, "q_change", "drier") && (has(answers, "q_change_context", "season") || has(answers, "q_change_context", "heating")) && scores.HYDRATION > 0) add(scores, "HYDRATION", 1, "Verandering/seizoen verfijnt bestaande droogtesignalen", events);
  if (has(answers, "q_change", "oilier") && scores.BALANCE > 0) add(scores, "BALANCE", 1, "Verandering verfijnt bestaande glanssignalen", events);
  if (has(answers, "q_change", "more_sensitive")) safety_flags.push("CHANGE_CAUTION");
  if (has(answers, "q_change_context", "sun") && insufficientSpf(answers)) add(scores, "PROTECT", 1, "Zon/vakantie/buiten + onvoldoende SPF", events);

  if (insufficientSpf(answers)) add(scores, "PROTECT", 3, "SPF onvoldoende dagelijks", events);
  if (canonical_facts.spf_frequency === "mostly") add(scores, "PROTECT", 1, "Meestal SPF: consequenter dagelijks", events);

  const rankedNeeds = NEEDS.filter((n) => n !== "PROTECT").sort((a, b) => scores[b] - scores[a]);
  let priority_need = rankedNeeds[0] && scores[rankedNeeds[0]] > 0 ? rankedNeeds[0] : null;
  let secondary_need = rankedNeeds[1] && scores[rankedNeeds[1]] > 1 ? rankedNeeds[1] : null;
  if (patterns.includes("cleansing_mismatch")) priority_need = "CLEANSING";
  if (patterns.includes("simplicity_over_more")) priority_need = scores.SENSITIVITY >= scores.BARRIER ? "SENSITIVITY" : "BARRIER";
  if (patterns.includes("age_support_dryness_lines") && scores.HYDRATION >= scores.AGE_SUPPORT) priority_need = "HYDRATION";

  const required_product_roles = rolesFor(priority_need, secondary_need, answers, patterns, scores);
  const confidence = confidenceFor(scores, answers, patterns);
  const matching = matchProducts({ answers, scores, priority_need, secondary_need, user_goal, patterns, required_product_roles, simplicity });
  const protect = protectDecision(answers, scores, patterns, canonical_facts);
  const result = buildResult({ answers, scores, priority_need, secondary_need, user_goal, patterns, safety_flags: uniq(safety_flags), confidence, matching, protect });
  const answer_traceability = buildAnswerTraceability(answers, events, patterns, matching, routine_context, protect);

  return {
    answers,
    canonical_facts,
    need_scores_raw: raw,
    need_scores_after_context: scores,
    score_events: events,
    answer_traceability,
    patterns,
    priority_need,
    secondary_need,
    user_goal,
    simplicity_preference: simplicity,
    routine_context,
    spf_context,
    change_context,
    safety_flags: uniq(safety_flags),
    confidence,
    required_product_roles,
    filtered_products: matching.filtered,
    ranking: matching.ranking,
    recommendations: matching.recommendations,
    protect_decision: protect,
    result,
  };
}

function applyMap(scores, map, selected, qid, events) {
  (selected || []).forEach((id) => (map[id] || []).forEach(([need, amount]) => add(scores, need, amount, `${qid} ${id}`, events)));
}

function insufficientSpf(a) {
  const facts = deriveCanonicalFacts(a);
  return ["sunny", "spring_summer", "rarely", "no"].includes(facts.spf_frequency);
}

function rolesFor(priority, secondary, answers, patterns, scores) {
  const roles = new Set();
  const addNeed = (need) => {
    if (need === "CLEANSING") roles.add("CLEANSER");
    if (need === "HYDRATION") { roles.add("MOISTURIZER"); if (!patterns.includes("cleansing_mismatch")) roles.add("SERUM"); }
    if (need === "BARRIER" || need === "SENSITIVITY") { roles.add("BARRIER_CREAM"); roles.add("SERUM"); }
    if (need === "RADIANCE" || need === "TONE") roles.add("SERUM");
    if (need === "AGE_SUPPORT") { roles.add("SERUM"); roles.add("FACIAL_OIL"); }
    if (need === "BALANCE") roles.add("MOISTURIZER");
    if (need === "CLARITY") roles.add("SERUM");
  };
  addNeed(priority);
  addNeed(secondary);
  if (eyeCareNeeded(answers)) roles.add("EYE_CARE");
  if (patterns.includes("simplicity_over_more")) roles.delete("MASK_TREATMENT");
  return [...roles];
}

function matchProducts(profile) {
  const filtered = [];
  const ranking = [];
  for (const product of PRODUCTS) {
    const reasons = [];
    if (product.status !== "ACTIVE") reasons.push("inactive");
    if (product.eligibility === "FALSE") reasons.push(product.lola_usage_tip || "niet eligible");
    if (!profile.required_product_roles.includes(product.product_role)) reasons.push("productrol niet gevraagd door profiel");
    if (product.product_role === "EYE_CARE" && !has(profile.answers, "q_eye", "yes")) reasons.push("oogcontour niet expliciet geselecteerd");
    if (profile.patterns.includes("simplicity_over_more") && ["MASK_TREATMENT", "BOOSTER", "TONER_ESSENCE"].includes(product.product_role)) reasons.push("routinecomplexiteit past niet bij eenvoud boven méér");
    if (reasons.length) {
      filtered.push({ product: product.title, reasons });
      continue;
    }
    let score = 0;
    const components = [];
    for (const [need, weight] of Object.entries(product.primary_needs)) {
      const needScore = profile.scores[need] || 0;
      const value = needScore * weight;
      if (value) { score += value; components.push(`${need} ${needScore}x${weight}`); }
    }
    if (profile.priority_need === "CLEANSING" && product.product_role === "CLEANSER") { score += 8; components.push("cleansing mismatch hoofdroute"); }
    if (profile.simplicity && product.can_replace_step) { score += 2; components.push("eenvoud/multifunctionaliteit"); }
    if (profile.patterns.includes("reactive_barrier_pressure") && product.sensitivity_fit === "GOOD") { score += 4; components.push("gevoeligheidsfit"); }
    if (profile.patterns.includes("dehydrated_shine") && product.primary_needs.BALANCE && !product.primary_needs.HYDRATION) { score -= 4; components.push("glans verdringt hydratatie niet"); }
    if (profile.patterns.includes("simplicity_over_more") && product.primary_needs.RADIANCE) { score -= 7; components.push("extra actieve glowstap onderdrukt"); }
    if (score >= 4) ranking.push({ product, score, components });
    else filtered.push({ product: product.title, reasons: ["onder minimale matchdrempel"] });
  }
  ranking.sort((a, b) => b.score - a.score || b.product.multifunctionality - a.product.multifunctionality || a.product.price - b.product.price);

  const chosen = [];
  const usedRoles = new Set();
  const usedFunctionalGroups = new Set();
  const allowSecondarySameSerum = profile.secondary_need && !profile.patterns.includes("simplicity_over_more") && !profile.patterns.includes("active_routine_context");
  const take = (item, assignedNeed = null) => {
    chosen.push({ ...item, assigned_need: assignedNeed || bestProductNeed(item.product, profile.scores) });
    usedRoles.add(item.product.product_role);
    usedFunctionalGroups.add(functionalRoutineGroup(item.product));
  };
  const first = selectBestCandidate(ranking.filter((item) => !shouldReserveSerumForSecondary(profile, item, ranking)), profile, chosen, profile.priority_need);
  if (first) take(first, first.product.primary_needs[profile.priority_need] ? profile.priority_need : null);
  const eyeCare = eyeCareNeeded(profile.answers) && !chosen.some((item) => item.product.product_role === "EYE_CARE")
    ? selectBestCandidate(ranking.filter((item) => item.product.product_role === "EYE_CARE"), profile, chosen, "EYE_CONTOUR")
    : null;
  if (eyeCare) take(eyeCare, "EYE_CONTOUR");
  const secondary = profile.secondary_need && !profile.patterns.includes("simplicity_over_more")
    ? selectBestCandidate(ranking.filter((item) => {
      if (chosen.some((chosenItem) => chosenItem.product === item.product) || !item.product.primary_needs[profile.secondary_need]) return false;
      if (recommendationRoleAlreadyCovered(item.product, usedRoles)) return false;
      if (!usedRoles.has(item.product.product_role)) return !usedFunctionalGroups.has(functionalRoutineGroup(item.product));
      return allowSecondarySameSerum && sameRoleAllowedForDistinctNeed(profile, chosen, item, profile.secondary_need);
    }), profile, chosen, profile.secondary_need)
    : null;
  if (secondary) take(secondary, profile.secondary_need);
  for (const item of ranking) {
    if (chosen.length >= 3) break;
    if (chosen.some((chosenItem) => chosenItem.product === item.product)) continue;
    if (recommendationRoleAlreadyCovered(item.product, usedRoles)) continue;
    const thirdNeed = chosen.length === 2 ? thirdNeedAllowed(profile, chosen, item.product) : null;
    if (chosen.length === 2 && !thirdNeed) continue;
    if (usedRoles.has(item.product.product_role) && !sameRoleAllowedForDistinctNeed(profile, chosen, item, thirdNeed)) continue;
    if (usedFunctionalGroups.has(functionalRoutineGroup(item.product)) && !sameRoleAllowedForDistinctNeed(profile, chosen, item, thirdNeed)) continue;
    take(item, thirdNeed);
  }
  return { filtered, ranking, recommendations: resolveStockForRecommendations(chosen, ranking, profile.scores) };
}

function recommendationRoleAlreadyCovered(product, usedRoles) {
  return product.product_role === "EYE_CARE" && usedRoles.has("EYE_CARE");
}

function selectBestCandidate(candidates, profile, chosen, assignedNeed) {
  if (!candidates.length) return null;
  const best = candidates[0];
  const comparable = candidates.filter((item) =>
    item.score === best.score &&
    item.product.product_role === best.product.product_role &&
    equivalentNeedFit(item.product, best.product, assignedNeed || bestProductNeed(best.product, profile.scores))
  );
  if (comparable.length < 2) return best;
  const usedBrands = new Set(chosen.map((item) => item.product.brand));
  const otherBrand = comparable.find((item) => !usedBrands.has(item.product.brand));
  if (otherBrand && usedBrands.has(best.product.brand)) return otherBrand;
  return comparable[stableIndex(profile.answers, assignedNeed || best.product.product_role, comparable.length)];
}

function equivalentNeedFit(product, bestProduct, need) {
  if (need === "EYE_CONTOUR") return product.product_role === bestProduct.product_role;
  if (!need) return true;
  return Boolean(product.primary_needs[need] && bestProduct.primary_needs[need]);
}

function stableIndex(answers, salt, length) {
  const text = `${salt}:${Object.entries(answers).sort(([a], [b]) => a.localeCompare(b)).map(([qid, ids]) => `${qid}=${ids.join(",")}`).join("|")}`;
  let hash = 0;
  for (let index = 0; index < text.length; index += 1) hash = (hash * 31 + text.charCodeAt(index)) >>> 0;
  return hash % length;
}

function eyeCareNeeded(answers) {
  return has(answers, "q_eye", "yes");
}

function sameRoleAllowedForDistinctNeed(profile, chosen, item, need) {
  if (!need || profile.patterns.includes("active_routine_context")) return false;
  if (item.product.product_role !== "SERUM") return false;
  if (!item.product.primary_needs[need]) return false;
  if (chosen.some((chosenItem) => chosenItem.product.primary_needs[need] || chosenItem.assigned_need === need)) return false;
  return directAnswerFragmentsForNeed(profile.answers, need).length > 0 && (profile.scores[need] || 0) >= 4;
}

function functionalRoutineGroup(product) {
  if (["MOISTURIZER", "BARRIER_CREAM"].includes(product.product_role)) return "CREAM_STEP";
  if (["SERUM", "BOOSTER"].includes(product.product_role)) return "SERUM_STEP";
  return product.product_role;
}

function thirdNeedAllowed(profile, chosen, product) {
  if (profile.patterns.includes("simplicity_over_more")) return null;
  const coveredNeeds = new Set(chosen.flatMap((item) => item.assigned_need ? [item.assigned_need] : Object.keys(item.product.primary_needs)));
  return Object.keys(product.primary_needs).find((need) => {
    if ((profile.scores[need] || 0) < 3) return false;
    if (coveredNeeds.has(need)) return false;
    return directAnswerFragmentsForNeed(profile.answers, need).length > 0;
  }) || null;
}

function shouldReserveSerumForSecondary(profile, item, ranking) {
  const secondaryNeedsThatOftenUseSerum = ["TONE", "RADIANCE", "AGE_SUPPORT"];
  if (!secondaryNeedsThatOftenUseSerum.includes(profile.secondary_need)) return false;
  if (item.product.product_role !== "SERUM") return false;
  if (profile.priority_need === "HYDRATION") {
    if (item.product.primary_needs[profile.secondary_need]) return false;
    return ranking.some((candidate) => candidate.product.product_role === "MOISTURIZER" && candidate.score >= 4);
  }
  if (["AGE_SUPPORT", "TONE", "RADIANCE"].includes(profile.priority_need) && item.product.primary_needs[profile.secondary_need]) {
    return ranking.some((candidate) =>
      candidate.product !== item.product &&
      candidate.product.primary_needs[profile.priority_need] &&
      !candidate.product.primary_needs[profile.secondary_need] &&
      candidate.score >= 4
    );
  }
  return false;
}

function resolveStockForRecommendations(chosen, ranking, scores) {
  const resolved = [];
  const usedProductIds = new Set();
  for (const item of chosen) {
    if (usedProductIds.has(item.product.product_id)) continue;
    const replacement = stockFallbackFor(item, ranking, resolved, scores, usedProductIds);
    if (replacement) {
      resolved.push({
        ...replacement,
        assigned_need: replacementAssignedNeed(item, replacement, scores),
        inventory: { status: "available", replaces: item.product.product_id },
      });
      usedProductIds.add(replacement.product.product_id);
      continue;
    }
    if (item.product.inventory_status === "IN_STOCK") {
      resolved.push({ ...item, inventory: { status: "available" } });
      usedProductIds.add(item.product.product_id);
      continue;
    }
    resolved.push({ ...item, inventory: { status: "out_of_stock", alternative: null } });
    usedProductIds.add(item.product.product_id);
  }
  return resolved;
}

function stockFallbackFor(item, ranking, alreadyChosen, scores, usedProductIds = new Set()) {
  if (item.product.inventory_status === "IN_STOCK") return null;
  const need = item.assigned_need || bestProductNeed(item.product, scores);
  return ranking.find((candidate) => {
    if (candidate.product === item.product) return false;
    if (candidate.product.inventory_status !== "IN_STOCK") return false;
    if (usedProductIds.has(candidate.product.product_id)) return false;
    if (alreadyChosen.some((chosenItem) => chosenItem.product.product_id === candidate.product.product_id)) return false;
    if (!sameFallbackSurface(item.product, candidate.product)) return false;
    if (!fallbackMatchesNeed(candidate.product, item.product, need, scores)) return false;
    return candidate.score >= fallbackThreshold(item);
  }) || null;
}

function fallbackThreshold(item) {
  return Math.max(4, Math.min(item.score - 2, Math.round(item.score * 0.2)));
}

function sameFallbackSurface(product, candidate) {
  if (product.product_role === candidate.product_role) return true;
  return functionalRoutineGroup(product) === "CREAM_STEP" && functionalRoutineGroup(candidate) === "CREAM_STEP";
}

function fallbackMatchesNeed(candidate, original, need, scores) {
  if (need === "EYE_CONTOUR") return candidate.product_role === "EYE_CARE";
  if (candidate.primary_needs[need]) return true;
  if (["SENSITIVITY", "BARRIER"].includes(need) && candidate.primary_needs.BARRIER) return true;
  if (need === "HYDRATION" && candidate.primary_needs.HYDRATION) return true;
  return equivalentNeedFit(candidate, original, bestProductNeed(original, scores));
}

function replacementAssignedNeed(originalItem, replacement, scores) {
  const originalNeed = originalItem.assigned_need || bestProductNeed(originalItem.product, scores);
  return replacement.product.primary_needs[originalNeed] ? originalNeed : bestProductNeed(replacement.product, scores);
}

function protectDecision(answers, scores, patterns, facts = deriveCanonicalFacts(answers)) {
  const reasons = [];
  const daily = facts.spf_frequency === "daily";
  const mostly = facts.spf_frequency === "mostly";
  const needsDaily = insufficientSpf(answers);
  const wantsFewLayers = has(answers, "q6b", "few_layers");
  const creamPlusSpf = has(answers, "q6c", "cream_plus_spf");
  const reapplyProblem = facts.spf_reapplication_need === "explicit";
  const protectReminder = protectCheckCopy(answers, facts);
  const cloudyReminder = ["sunny", "spring_summer"].includes(facts.spf_frequency);

  if (needsDaily) reasons.push("SPF alleen bij zon/lente-zomer/zelden/nee of pigment-SPF onvoldoende");
  if (mostly) reasons.push("Meestal SPF: lichte aansporing tot consequente dagelijkse toepassing");
  if (daily) reasons.push("Dagelijks SPF: niet automatisch klaar; Q6A/Q6B/Q6C bepalen routine-fit");
  if (wantsFewLayers && creamPlusSpf) reasons.push("Dagcrème + losse SPF + wens voor minder lagen");
  if (reapplyProblem) reasons.push("Bijwerken is lastig of expliciet gewenst");

  const baseNeedsRecommendation = needsDaily;
  const baseRanking = rankProtectProducts("DAILY_SPF", { answers, scores, patterns, wantsFewLayers, creamPlusSpf, reapplyProblem });
  const reapplicationRanking = reapplyProblem ? rankProtectProducts("SPF_REAPPLICATION", { answers, scores, patterns, wantsFewLayers, creamPlusSpf, reapplyProblem }) : [];
  const dailyBaseSpf = baseNeedsRecommendation ? resolveStockForProtect(baseRanking[0], baseRanking, scores) : null;
  const reapplicationSpf = resolveStockForProtect(reapplicationRanking[0], reapplicationRanking, scores);

  if (!baseNeedsRecommendation && !reapplyProblem) {
    return {
      type: "check",
      copy: protectReminder,
      reasons,
      daily_base_spf: null,
      reapplication_spf: null,
      ranking: [],
      cloudyReminder: false,
    };
  }

  return {
    type: needsDaily || mostly ? "daily_needed" : "optimization",
    reasons,
    daily_base_spf: dailyBaseSpf,
    reapplication_spf: reapplicationSpf,
    recommendation: dailyBaseSpf || reapplicationSpf || null,
    ranking: { DAILY_BASE_SPF: baseRanking, REAPPLICATION_SPF: reapplicationRanking },
    cloudyReminder,
  };
}

function protectCheckCopy(answers, facts) {
  if (facts.spf_frequency === "mostly") {
    return "Protect is al onderdeel van je routine. Mooi. Probeer SPF ook op de dagen dat je hem nog weleens overslaat te gebruiken. Denk er daarnaast aan om je SPF gedurende de dag opnieuw aan te brengen, zeker wanneer je veel buiten bent, zweet of je huid afdroogt.";
  }
  if (facts.spf_reapplication_need === "already_reapplying") {
    return "Protect? Check. Je gebruikt dagelijks SPF en brengt die later op de dag opnieuw aan. Lekker zo houden.";
  }
  if (facts.spf_reapplication_need === "reminder") {
    return "Protect? Check. Je dagelijkse SPF zit al goed. Denk er ook aan om je bescherming gedurende de dag bij te werken, vooral wanneer je veel buiten bent, zweet of je huid afdroogt.";
  }
  if (facts.spf_reapplication_need === "varies") {
    return "Protect? Check. Je gebruikt al dagelijks SPF. Denk er op dagen waarop het nodig is ook aan om je bescherming gedurende de dag bij te werken.";
  }
  if (has(answers, "q6a", "morning")) {
    return "Protect? Check. Je gebruikt al dagelijks SPF. Lekker zo houden. Denk er ook aan om je SPF gedurende de dag opnieuw aan te brengen, zeker wanneer je veel buiten bent, zweet of je huid afdroogt.";
  }
  return "Protect? Check. Je gebruikt al dagelijks SPF en hebt aangegeven dat dit goed bij je routine past. Lekker zo houden.";
}

function resolveStockForProtect(item, ranking, scores) {
  if (!item) return null;
  if (item.product.inventory_status === "IN_STOCK") return { ...item, inventory: { status: "available" } };
  const replacement = stockFallbackFor({ ...item, assigned_need: "PROTECT" }, ranking, [], scores);
  if (replacement) return { ...replacement, inventory: { status: "available", replaces: item.product.product_id } };
  return { ...item, inventory: { status: "out_of_stock", alternative: null } };
}

function rankProtectProducts(role, context) {
  const { answers, scores, patterns, wantsFewLayers, creamPlusSpf, reapplyProblem } = context;
  const candidates = PRODUCTS.filter((p) => p.status === "ACTIVE" && p.eligibility !== "FALSE" && p.product_role === role);
  const ranking = candidates.map((product) => {
    let score = product.primary_needs.PROTECT || 0;
    const components = [role === "DAILY_SPF" ? "DAILY_BASE_SPF" : "REAPPLICATION_SPF"];
    if (scores.HYDRATION > 0 && scores.HYDRATION >= scores.BALANCE && product.primary_needs.HYDRATION) { score += 3; components.push("hydratatie weegt mee"); }
    if (scores.BALANCE > scores.HYDRATION && product.primary_needs.BALANCE && !patterns.includes("dehydrated_shine")) { score += 3; components.push("balans/finish weegt mee"); }
    if (scores.RADIANCE > 1 && product.primary_needs.RADIANCE) { score += 2; components.push("glowvoorkeur/context"); }
    if (scores.TONE > 1 && product.primary_needs.TONE) { score += 2; components.push("teintcontext"); }
    if (wantsFewLayers && creamPlusSpf && product.can_replace_step) { score += 4; components.push("kan stap vervangen"); }
    if (has(answers, "q6b", "light") && spfClaimIncludes(product, ["licht"])) { score += 3; components.push("lichtheid"); }
    if (has(answers, "q6b", "non_sticky") && spfClaimIncludes(product, ["droger aanvoelende finish"])) { score += 4; components.push("niet vet/plakkerig gevoel"); }
    if (has(answers, "q6b", "glow") && product.primary_needs.RADIANCE) { score += 4; components.push("glow"); }
    if (has(answers, "q6b", "makeup") && spfClaimIncludes(product, ["onder make-up", "over make-up"])) { score += 3; components.push("make-up fit"); }
    if (reapplyProblem && product.product_role === "SPF_REAPPLICATION") { score += 4; components.push("bijwerken"); }
    if (has(answers, "q6b", "top_up") && spfClaimIncludes(product, ["bijwerken"])) { score += 3; components.push("makkelijk bijwerken"); }
    if (has(answers, "q6b", "bag") && (product.use_context === "AS_NEEDED" || spfClaimIncludes(product, ["mee te nemen"]))) { score += 2; components.push("tas/meenemen"); }
    if (has(answers, "q6b", "few_layers") && spfClaimIncludes(product, ["moisturizer + SPF", "kan lagen beperken"])) { score += 2; components.push("minder lagen/producten"); }
    if (patterns.includes("dehydrated_shine") && product.primary_needs.BALANCE && !product.primary_needs.HYDRATION) { score -= 5; components.push("geen matte SPF door glans alleen"); }
    return { product, score, components };
  }).sort((a, b) => {
    const multifunctionalityTieBreak = role === "DAILY_SPF" ? b.product.multifunctionality - a.product.multifunctionality : 0;
    return b.score - a.score || multifunctionalityTieBreak || a.product.title.localeCompare(b.product.title);
  });
  return ranking;
}

function spfClaimIncludes(product, fragments) {
  const text = product.why_blocks.join(" ").toLowerCase();
  return fragments.some((fragment) => text.includes(fragment.toLowerCase()));
}

function buildResult(profile) {
  const recs = profile.matching.recommendations;
  const noClearNeed = !profile.priority_need && has(profile.answers, "q1", "nothing") && has(profile.answers, "q3", "comfortable");
  const noProductMatch = !noClearNeed && recs.length === 0;
  const overloaded = profile.patterns.includes("simplicity_over_more");
  const displayRecs = orderRecommendationsForDisplay(recs);
  const blocks = displayRecs.map((r, i) => resultBlock(r, i, profile));
  return {
    heading: "Dit past bij jouw huid",
    intro: noClearNeed
      ? "Je huid lijkt op dit moment vooral baat te hebben bij rust en eenvoud."
      : resultIntro(blocks, noProductMatch),
    noClearNeed,
    noProductMatch,
    overloaded,
    lowConfidence: profile.confidence === "LOW",
    blocks,
    protect: profile.protect,
    safetyNote: safetyNoteFor(profile.safety_flags),
  };
}

function orderRecommendationsForDisplay(recommendations) {
  if (!recommendations.some((item) => item.product.product_role === "EYE_CARE")) return recommendations;
  const essential = recommendations.filter((item) => essentialRoutineRole(item.product));
  if (essential.length < 2) return recommendations;
  return [
    ...recommendations.filter((item) => item.product.product_role !== "EYE_CARE"),
    ...recommendations.filter((item) => item.product.product_role === "EYE_CARE"),
  ];
}

function essentialRoutineRole(product) {
  return ["CLEANSER", "SERUM", "MOISTURIZER", "BARRIER_CREAM"].includes(product.product_role);
}

function resultBlock(item, index, profile) {
  const headings = ["Begin hiermee", "Combineer met", "Als extra stap"];
  const product = item.product;
  const productNeed = item.assigned_need || bestProductNeed(product, profile.scores);
  const reason = cardProductReason(product);
  return { heading: headings[index], product, need: productNeed, reason, inventory: item.inventory, components: item.components };
}

function bestProductNeed(product, scores) {
  return Object.keys(product.primary_needs).sort((a, b) => (scores[b] || 0) - (scores[a] || 0))[0] || "deze behoefte";
}

function sourceAnswers(answers) {
  const out = [];
  for (const [qid, ids] of Object.entries(answers)) {
    ids.forEach((id) => {
      const fragment = RESULT_FRAGMENTS[qid]?.[id];
      if (fragment) out.push(fragment);
    });
  }
  return out;
}

function sourceAnswersForNeed(answers, need) {
  const direct = directAnswerFragmentsForNeed(answers, need);
  if (direct.length) return direct;
  return sourceAnswers(answers);
}

function directAnswerFragmentsForNeed(answers, need) {
  const out = [];
  for (const [qid, ids] of Object.entries(answers)) {
    ids.forEach((id) => {
      const hints = ANSWER_NEED_HINTS[qid]?.[id] || [];
      const fragment = RESULT_FRAGMENTS[qid]?.[id];
      if (fragment && hints.includes(need)) out.push(fragment);
    });
  }
  return out;
}

function sourceAnswersForProduct(answers, product, need) {
  if (product.product_role === "EYE_CARE") {
    const eye = ["q_eye"].flatMap((qid) => (answers[qid] || []).map((id) => RESULT_FRAGMENTS[qid]?.[id]).filter(Boolean));
    if (eye.length) return eye;
  }
  return sourceAnswersForNeed(answers, need);
}

function resultIntro(blocks, noProductMatch = false) {
  if (noProductMatch) {
    return "LOLA zou hier nu niet zomaar een product aan toevoegen. De huidige selectie bevat geen product dat met genoeg vertrouwen past bij deze specifieke behoefte.";
  }
  const advisedNeeds = uniq(blocks.map((block) => block.need).filter(Boolean));
  const regularNeeds = advisedNeeds.filter((need) => need !== "EYE_CONTOUR");
  const eye = advisedNeeds.includes("EYE_CONTOUR");
  const needText = summaryNeedText(regularNeeds) || "passende, eenvoudige ondersteuning";
  const eyeText = eye ? " Ook de huid rond je ogen mag wat extra aandacht krijgen." : "";
  return `Je huid vraagt vooral om ${needText}.${eyeText} Dit zou LOLA kiezen:`;
}

function summaryNeedText(needs) {
  if (needs.includes("HYDRATION") && needs.includes("BARRIER")) {
    const combined = "meer hydratatie, comfort en ondersteuning van je huidbarrière";
    return naturalJoin([combined, ...needs.filter((need) => !["HYDRATION", "BARRIER"].includes(need)).map(summaryNeedCopy)]);
  }
  return naturalJoin(needs.map(summaryNeedCopy));
}

function summaryNeedCopy(need) {
  return ({
    HYDRATION: "meer hydratatie en comfort",
    BARRIER: "comfort en ondersteuning van je huidbarrière",
    SENSITIVITY: "meer rust en minder gevoeligheid",
    BALANCE: "meer balans",
    CLARITY: "meer helderheid rond onzuiverheden",
    RADIANCE: "een frissere uitstraling",
    TONE: "een egalere teint",
    AGE_SUPPORT: "ondersteuning bij fijne lijntjes en stevigheid",
    CLEANSING: "een mildere reinigingsstap",
    EYE_CONTOUR: "extra aandacht voor de huid rond je ogen",
  })[need] || needCopy(need);
}

function buildAnswerTraceability(answers, events, patterns, matching, routineContext, protect) {
  const traces = [];
  for (const [question_id, ids] of Object.entries(answers)) {
    ids.forEach((answer_id) => {
      const hints = ANSWER_NEED_HINTS[question_id]?.[answer_id] || [];
      const fragment = RESULT_FRAGMENTS[question_id]?.[answer_id] || label(question_id, answer_id);
      const effects = [];
      hints.forEach((need) => {
        const scoring = events.filter((event) => event.need === need && eventMatchesQuestion(question_id, event.source));
        if (scoring.length) effects.push(`need scoring: ${need} via ${scoring.map((event) => event.source).join(" / ")}`);
        else effects.push(`signal/context: ${need}`);
        const ranked = matching.ranking.filter((item) => item.product.primary_needs[need]).map((item) => item.product.product_id);
        if (ranked.length) effects.push(`product ranking: ${need} candidates ${ranked.slice(0, 3).join(", ")}`);
        const recommended = matching.recommendations.filter((item) => item.assigned_need === need).map((item) => item.product.product_id);
        if (recommended.length) effects.push(`recommendation: ${recommended.join(", ")}`);
        if (!recommended.length && ranked.length) effects.push(`not recommended: ${need} ranked but another fit won or routine limits applied`);
      });
      if (question_id === "q_eye" && eyeCareNeeded(answers)) {
        const eyeRecommendation = matching.recommendations.find((item) => item.assigned_need === "EYE_CONTOUR");
        effects.push(eyeRecommendation ? `recommendation: ${eyeRecommendation.product.product_id}` : "not recommended: oogcontour ranked but another fit won or routine limits applied");
      }
      if (question_id === "q5" && answer_id === "many_actives") {
        effects.push(routineContext.effect || "routine/context: extra actives terughoudender beoordelen");
      }
      if (question_id === "q_actives" && ["regular", "sometimes", "unknown"].includes(answer_id)) {
        effects.push(routineContext.active_ingredients_effect || "routine/context: actieve ingrediënten stapelen niet automatisch extra actieve producten");
      }
      if (question_id === "q_pigment_since") {
        effects.push("context: duur van pigment-/teintvraag vastgelegd; geen zelfstandige productboost");
      }
      if (question_id.startsWith("q6") && protect.type !== "check") {
        effects.push(`Protect decision: ${protect.type}`);
      }
      if (patterns.length && hints.some((need) => ["SENSITIVITY", "BARRIER", "HYDRATION", "TONE", "AGE_SUPPORT"].includes(need))) {
        effects.push(`pattern context: ${patterns.join(", ")}`);
      }
      traces.push({ question_id, answer_id, answer: fragment, needs: hints, effects: uniq(effects) });
    });
  }
  return traces;
}

function eventMatchesQuestion(questionId, source) {
  const prefixes = {
    q1: "Q1",
    q2: "Q2",
    q2b: "Q2B",
    q3: "Q3",
    q4: "Q4",
    q_sens_how: "Gevoeligheid:",
    q_sens_freq: "Gevoeligheid",
    q_pigment_type: "Donkere vlekjes|Zon-/pigmentvlekjes|Algemene verkleuring|Roodheid maakt teint",
    q_age_support: "Fijne lijntjes|Stevigheid|Droogtelijntjes|Doffere/vermoeide",
    q_age_skin: "Age-context",
    q_dull_type: "Mist glow|Dof en droog|Grauw/vermoeid|Ruw/minder glad",
  };
  const pattern = prefixes[questionId];
  if (!pattern) return false;
  return new RegExp(pattern).test(source);
}

function naturalJoin(items) {
  if (items.length <= 1) return items[0] || "";
  if (items.length === 2) return `${items[0]} en ${items[1]}`;
  return `${items.slice(0, -1).join(", ")} en ${items[items.length - 1]}`;
}

function displayProductTitle(title) {
  return title
    .replace(/\s+\d+(?:[,.]\d+)?\s*(?:ml|mL|ML|gr|g)\b\.?\s*$/g, "")
    .replace(/\s{2,}/g, " ")
    .trim();
}

function productTitle(product) {
  return product.display_title || displayProductTitle(product.title);
}

function productReason(product) {
  return PRODUCT_CUSTOMER_REASONS[product.product_id] || "het aansluit op de behoefte die uit je antwoorden naar voren komt.";
}

function cardProductReason(product) {
  return PRODUCT_CARD_REASONS[product.product_id] || `${protectReason(product)}.`;
}

function usageLine(product) {
  const when = ({
    AM: "'s ochtends",
    PM: "'s avonds",
    AM_PM: "'s ochtends en/of 's avonds",
    AS_NEEDED: "wanneer nodig",
  })[product.use_context] || "volgens je routine";
  if (product.product_role === "SERUM") return `Gebruik: ${when}, vóór je moisturizer.`;
  if (["MOISTURIZER", "BARRIER_CREAM"].includes(product.product_role)) return `Gebruik: ${when} als moisturizer.`;
  if (product.product_role === "FACIAL_OIL") return `Gebruik: ${when} als latere verzorgende stap.`;
  if (product.product_role === "EYE_CARE") return `Gebruik: ${when} rond de oogcontour.`;
  if (product.product_role === "CLEANSER") return `Gebruik: ${when} tijdens het reinigen.`;
  if (product.product_role === "DAILY_SPF") return product.can_replace_step ? "Gebruik: 's ochtends als laatste verzorgende SPF-stap." : "Gebruik: 's ochtends als laatste stap over je verzorging.";
  if (product.product_role === "SPF_REAPPLICATION") return "Gebruik: gedurende de dag om je SPF bij te werken.";
  return `Gebruik: ${when}.`;
}

function protectReason(product) {
  const reason = productReason(product).replace(/^het\s+/, "").replace(/\sis die\s/, " die ");
  return `${reason.charAt(0).toUpperCase()}${reason.slice(1)}`;
}

function safetyNoteFor(flags) {
  if (!flags.some((flag) => ["MEDICAL_CAUTION", "CHANGE_CAUTION"].includes(flag))) return null;
  if (flags.includes("MEDICAL_CAUTION")) {
    return "<strong>Blijven je klachten aanhouden?</strong><br>Skincare kan je huid ondersteunen, maar diepere, pijnlijke of aanhoudende ontstekingen vragen soms om meer. Bespreek ze dan met je huisarts of dermatoloog.";
  }
  return "<strong>Blijft je huid plots anders reageren?</strong><br>Skincare kan een gevoelige huid ondersteunen, maar aanhoudende of ernstige huidklachten vragen soms om meer. Bespreek ze dan met je huisarts of dermatoloog.";
}

function label(qid, id) {
  const q = qs(qid);
  return q?.options.find((o) => o[0] === id)?.[1] || id;
}

function needCopy(need) {
  return ({
    HYDRATION: "meer hydratatie en comfort",
    BARRIER: "comfort en ondersteuning van je huidbarrière",
    SENSITIVITY: "meer rust en minder gevoeligheid",
    BALANCE: "meer balans",
    CLARITY: "meer helderheid rond onzuiverheden",
    RADIANCE: "een frissere, stralendere uitstraling",
    TONE: "een egalere teint",
    AGE_SUPPORT: "ondersteuning bij fijne lijntjes en stevigheid",
    EYE_CONTOUR: "extra aandacht voor de huid rond je ogen",
    CLEANSING: "een mildere reinigingsstap",
  })[need] || "eenvoudige, passende verzorging";
}

function additionNeedCopy(need) {
  return ({
    EYE_CONTOUR: "extra aandacht voor de huid rond je ogen",
    TONE: "ondersteuning voor een egalere teint",
    AGE_SUPPORT: "ondersteuning bij fijne lijntjes en stevigheid",
    HYDRATION: "meer hydratatie en comfort",
    BARRIER: "comfort en ondersteuning van je huidbarrière",
    SENSITIVITY: "meer rust en minder gevoeligheid",
    BALANCE: "meer balans",
    CLARITY: "meer helderheid rond onzuiverheden",
    RADIANCE: "een frissere, stralendere uitstraling",
    CLEANSING: "een mildere reinigingsstap",
  })[need] || needCopy(need);
}

function confidenceFor(scores, answers, patterns) {
  const known = Object.values(answers).flat().filter((id) => !["unsure", "unknown", "varies"].includes(id)).length;
  const top = NEEDS.map((n) => scores[n]).sort((a, b) => b - a);
  if (known < 5 || top[0] < 3) return "LOW";
  if (top[0] >= 6 && top[0] - top[1] >= 2 && patterns.length <= 2) return "HIGH";
  return "MEDIUM";
}

function uniq(items) {
  return [...new Set(items)];
}

function render() {
  const app = document.getElementById("lola-skin-check-root") || document.getElementById("app");
  if (!app) return;
  if (state.step === "landing") return app.innerHTML = landing();
  if (state.step === "result") return app.innerHTML = resultView();
  app.innerHTML = quizView();
}

function landing() {
  return `
    <section class="hero">
      <div class="hero-copy">
        <div class="brand-reserve" aria-label="Ruimte voor het officiële Selected by LOLA-logo">Selected by LOLA</div>
        <div class="eyebrow">More skin. Less hype.</div>
        <h1>Niet zeker welke skincare je moet kiezen?</h1>
        <p>Iedere huid is anders. En je huid blijft ook niet altijd hetzelfde. Leeftijd, hormonen, seizoenswisselingen en invloeden van buitenaf kunnen ervoor zorgen dat je huid in de loop van de tijd andere behoeften krijgt.</p>
        <p>Tussen alle producten en adviezen is het niet altijd makkelijk om te bepalen wat écht bij jouw huid past. Daarom kijkt LOLA met je mee.</p>
        <p>Doe de LOLA Skin Check en vertel hoe je huid doorgaans aanvoelt en wat je graag wilt bereiken. LOLA kijkt naar je antwoorden in samenhang en helpt je op weg met persoonlijk productadvies dat past bij jouw huid en je routine.</p>
        <p>Je huid kan in de loop van de tijd veranderen. Merk je dat je huid anders aanvoelt of andere behoeften krijgt? Dan kun je de Skin Check altijd opnieuw doen. Je hoeft daarvoor niet meteen je hele routine om te gooien. Soms is een kleine aanpassing al genoeg.</p>
        <button class="btn" onclick="startQuiz()">Start de Skin Check</button>
        <p class="meta">± 2–3 minuten • Vanzelfsprekend vrijblijvend. 🤍</p>
        <p class="disclaimer">Goed om te weten: de LOLA Skin Check helpt je op weg met skincare en productadvies. Het is geen medisch of dermatologisch advies. Heb je aanhoudende of ernstige huidklachten? Dan adviseren we je contact op te nemen met je huisarts of dermatoloog.</p>
      </div>
      <div class="hero-visual"><img src="${skinCheckAsset("hero", "./LOLA_Skin_Check_Hero.png")}" alt="Warme spiegelsetting met echte huid en rustige luxe"></div>
    </section>`;
}

function quizView() {
  const visible = getVisibleQuestions();
  const q = visible[state.index] || visible[0];
  const selected = state.answers[q.id] || [];
  const progress = Math.round(((state.index + 1) / visible.length) * 100);
  return `
    <section class="layout">
      <div class="panel">
        <div class="quiz-brand"><span>Selected by LOLA</span><span>Skin Check</span></div>
        <h2>${q.title}</h2>
        ${questionInstruction(q) ? `<p class="question-note">${questionInstruction(q)}</p>` : ""}
        <div class="progress" aria-label="Voortgang"><span style="width:${progress}%"></span></div>
        <div id="error" class="error" hidden></div>
        <div class="options">${q.options.map(([id, text]) => option(q, id, text, selected.includes(id))).join("")}</div>
        <div class="button-row">
          <button class="btn secondary" onclick="prevQuestion()" ${state.index === 0 ? "disabled" : ""}>Vorige</button>
          <button class="btn" onclick="nextQuestion()">${state.index === visible.length - 1 ? "Bekijk mijn advies" : "Volgende"}</button>
        </div>
      </div>
      ${isDebugMode() ? debugView() : ""}
    </section>`;
}

function option(q, id, text, checked) {
  const type = q.type === "multi" ? "checkbox" : "radio";
  const inputId = `${q.id}-${id}`;
  return `<label class="option" for="${inputId}"><input id="${inputId}" type="${type}" name="${q.id}" value="${id}" ${checked ? "checked" : ""} onchange="setAnswer('${q.id}','${id}',${q.type === "multi"})" /> <span>${text}</span></label>`;
}

function questionInstruction(q) {
  if (q.type !== "multi") return q.helper || "Kies één antwoord.";
  if (q.helper) return q.helper;
  if (q.max === 2) return "Kies maximaal twee antwoorden.";
  return "Kies alles wat voor jou belangrijk is.";
}

function resultView() {
  const debug = assess(state.answers);
  state.debug = debug;
  const r = debug.result;
  return `
    <section class="layout">
      <div class="panel">
        <div class="eyebrow">Jouw advies</div>
        <h2>${r.heading}</h2>
        ${r.lowConfidence ? `<p class="notice">Je antwoorden geven niet één heel duidelijke richting. Je huid kan zich wisselend gedragen en niet alles laat zich makkelijk in een vakje stoppen.</p>` : ""}
        ${r.overloaded ? `<p class="notice"><strong>Soms is minder juist beter.</strong><br>Op basis van wat je hebt verteld, zou LOLA nu niet méér aan je routine toevoegen.</p>` : ""}
        ${r.noClearNeed ? `<p class="notice"><strong>Lekker zo houden.</strong><br>Je huid voelt over het algemeen comfortabel en je routine sluit aan bij wat je zoekt. Heb je producten waar je prettig mee werkt? Blijf die dan vooral gebruiken. Meer skincare is niet automatisch betere skincare.</p>` : `<p>${r.intro}</p>`}
        ${r.blocks.length ? `<p><em>Je hoeft je routine niet helemaal om te gooien. Kijk vooral welke van deze producten een goede aanvulling is op wat je al gebruikt.</em></p>` : ""}
        <div class="result-grid">${r.blocks.map(renderBlock).join("")}</div>
        ${renderProtect(r.protect)}
        ${r.safetyNote ? `<p class="notice">${r.safetyNote}</p>` : ""}
        <p class="notice"><strong>Geef je huid de tijd</strong><br>Goede skincare hoeft niet ingewikkeld te zijn. Geef je huid en je producten de tijd. Meer is niet altijd beter; wat bij jou past, is belangrijker.<br>En zorg ook een beetje goed voor jezelf. 🤍</p>
        <div class="endshot" role="img" aria-label="Open LOLA-doos met kaartje: You are beautiful. Just the way you are."></div>
        <div class="button-row"><button class="btn secondary" onclick="state.step='quiz'; render()">Terug naar vragen</button><button class="btn" onclick="resetAll()">Opnieuw starten</button></div>
      </div>
      ${isDebugMode() ? debugView(debug) : ""}
    </section>`;
}

function renderBlock(block) {
  const title = productTitle(block.product);
  return `<article class="result-card">
    ${productMedia(block.product)}
    <div>
      <h3>${block.heading}</h3>
      <strong>${title}</strong>
      <p><strong>Waarom deze?</strong><br>${block.reason}</p>
      <p><strong>${usageLine(block.product)}</strong></p>
      ${block.inventory.status === "out_of_stock" ? `<p class="notice">LOLA zou nog steeds voor deze kiezen. ${title} past het beste bij wat je hebt verteld, maar is helaas tijdelijk niet op voorraad. ${block.inventory.alternative ? `Liever niet wachten? Dan zou LOLA ${productTitle(block.inventory.alternative)} adviseren.` : ""}</p><button class="btn secondary">Laat me weten wanneer deze er weer is</button>` : productLink(block.product)}
    </div>
  </article>`;
}

function renderProtect(protect) {
  if (protect.type === "check") return `<p class="notice">${protect.copy}</p>`;
  const blocks = [];
  if (protect.daily_base_spf) {
    const item = protect.daily_base_spf;
    const cloudy = protect.cloudyReminder ? " Ook op bewolkte dagen blijft dagelijkse SPF belangrijk." : "";
    const prefix = protect.type === "daily_needed" ? `<strong>Nog één ding: Protect</strong><br>Maak van SPF een dagelijkse gewoonte.${cloudy} Deze past het beste bij wat jij belangrijk vindt:` : "<strong>Protect zit al in je routine.</strong><br>Deze vorm kan beter passen bij wat jij belangrijk vindt:";
    blocks.push(`<article class="result-card">${productMedia(item.product, "Protect")}<div><p>${prefix}</p><strong>${productTitle(item.product)}</strong><p>${protectReason(item.product)}</p><p><strong>${usageLine(item.product)}</strong></p>${item.inventory?.status === "out_of_stock" ? `<p class="notice">Deze SPF past het beste bij wat je hebt verteld, maar is helaas tijdelijk niet op voorraad.</p><button class="btn secondary">Laat me weten wanneer deze er weer is</button>` : productLink(item.product)}</div></article>`);
  }
  if (protect.reapplication_spf) {
    const item = protect.reapplication_spf;
    blocks.push(`<article class="result-card">${productMedia(item.product, "Bijwerken")}<div><p><strong>Voor later op de dag</strong><br>Deze vorm maakt opnieuw aanbrengen makkelijker naast je ochtend-SPF.</p><strong>${productTitle(item.product)}</strong><p>${protectReason(item.product)}</p><p><strong>${usageLine(item.product)}</strong></p>${item.inventory?.status === "out_of_stock" ? `<p class="notice">Deze SPF-vorm past het beste bij wat je hebt verteld, maar is helaas tijdelijk niet op voorraad.</p><button class="btn secondary">Laat me weten wanneer deze er weer is</button>` : productLink(item.product)}</div></article>`);
  }
  return blocks.join("");
}

function productMedia(product, label = "") {
  const fallback = `${product.brand}${label ? `<br>${label}` : ""}`;
  if (!product.image_url) return `<div class="packshot">${fallback}</div>`;
  return `<div class="packshot packshot--image"><img src="${escapeHtml(product.image_url)}" alt="${escapeHtml(product.image_alt || `${productTitle(product)} packshot`)}" loading="lazy"></div>`;
}

function productLink(product) {
  if (!product.url || product.url === "#") return `<button class="btn secondary">Bekijk product</button>`;
  return `<a class="btn secondary" href="${escapeHtml(product.url)}" data-lola-product-id="${escapeHtml(product.product_id)}">Bekijk product</a>`;
}

function debugView(debug = state.debug || assess(state.answers)) {
  return `<aside class="debug-panel"><h3>Development/debug</h3><button class="btn secondary" onclick="runAcceptanceTests()">Run acceptatietests</button>${state.testResults ? testSummary() : ""}<pre>${escapeHtml(JSON.stringify(debug, null, 2))}</pre></aside>`;
}

function testSummary() {
  const passed = state.testResults.filter((t) => t.pass).length;
  return `<p><span class="${passed === state.testResults.length ? "test-pass" : "test-fail"}">${passed}/${state.testResults.length} acceptatietests geslaagd</span></p><ul>${state.testResults.map((t) => `<li class="${t.pass ? "test-pass" : "test-fail"}">${t.name}</li>`).join("")}</ul>`;
}

function escapeHtml(s) {
  return s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
}

function startQuiz() {
  state.step = "quiz";
  state.index = 0;
  state.answers = {};
  render();
}

function setAnswer(qid, id, multi) {
  const q = qs(qid);
  const current = state.answers[qid] || [];
  if (multi) {
    const exists = current.includes(id);
    const next = exists ? current.filter((x) => x !== id) : [...current, id];
    if (q.max && next.length > q.max) {
      document.getElementById("error").hidden = false;
      document.getElementById("error").textContent = "Kies maximaal twee antwoorden.";
      return render();
    }
    state.answers[qid] = next;
  } else {
    state.answers[qid] = [id];
  }
  state.answers = cleanAnswers(state.answers);
  state.debug = assess(state.answers);
  render();
}

function nextQuestion() {
  const visible = getVisibleQuestions();
  const q = visible[state.index];
  if (!state.answers[q.id]?.length) {
    document.getElementById("error").hidden = false;
    document.getElementById("error").textContent = "Kies een antwoord om verder te gaan.";
    return;
  }
  if (state.index >= visible.length - 1) state.step = "result";
  else state.index += 1;
  state.answers = cleanAnswers(state.answers);
  render();
}

function prevQuestion() {
  state.index = Math.max(0, state.index - 1);
  render();
}

function resetAll() {
  state = { answers: {}, step: "landing", index: 0, debug: null, testResults: null };
  render();
}

function runAcceptanceTests() {
  const cases = acceptanceProfiles().map((tc) => {
    const d = assess(tc.answers);
    return { name: tc.name, pass: tc.expect(d), debug: d };
  });
  state.testResults = cases;
  render();
  console.table(cases.map(({ name, pass }) => ({ name, pass })));
}

function acceptanceProfiles() {
  return [
    { name: "Cleansing mismatch", answers: { q1: ["dry"], q_change: ["same"], q2: ["slightly_tight"], q2a: ["foam_gel"], q2b: ["comfortable"], q3: ["comfortable"], q4: ["hydration"], q5: ["cleanser_cream"], q6: ["no"], q6a: ["forget"], q6b: ["none"] }, expect: (d) => d.patterns.includes("cleansing_mismatch") && d.priority_need === "CLEANSING" && !d.recommendations.some((r) => r.product.product_role === "SERUM") },
    { name: "Dehydrated + shine", answers: { q1: ["dry", "shine"], q_change: ["same"], q2: ["slightly_tight"], q2a: ["foam_gel"], q2b: ["shiny_tight"], q3: ["tzone"], q4: ["hydration"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"] }, expect: (d) => d.patterns.includes("dehydrated_shine") && d.need_scores_after_context.HYDRATION >= d.need_scores_after_context.BALANCE && d.protect_decision.type === "check" },
    { name: "Lines + missing SPF", answers: { q1: ["lines"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["age", "simple"], q5: ["cleanser_cream"], q6: ["sunny"], q6a: ["morning"], q6b: ["few_layers"], q6c: ["cream_plus_spf"], q_age_support: ["lines"], q_eye: ["no"], q_age_skin: ["comfortable"], q_actives: ["no"] }, expect: (d) => d.recommendations.some((r) => ["SERUM", "FACIAL_OIL"].includes(r.product.product_role)) && d.protect_decision.type === "daily_needed" },
    { name: "Pigment + glow + missing SPF", answers: { q1: ["pigment"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["tone", "glow"], q5: ["cleanser_serum_cream"], q6: ["sunny"], q6a: ["morning"], q6b: ["glow"], q_pigment_type: ["sun_spots"], q_pigment_since: ["longer"], q_pigment_spf: ["sunny"], q_dull_type: ["no_glow"], q_dull_sensitive: ["no"] }, expect: (d) => d.recommendations[0]?.product.product_id === "cb-sophia" && d.protect_decision.type === "daily_needed" },
    { name: "Reactive + actives + glow", answers: { q1: ["redness", "dry", "dull"], q_change: ["more_sensitive"], q_change_context: ["new_product"], q2: ["sensitive"], q2a: ["foam_gel"], q2b: ["sensitive"], q3: ["sensitive_red"], q4: ["glow"], q5: ["many_actives"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_sens_how: ["stings", "fragile"], q_sens_freq: ["almost_always"], q_red_duration: ["hours"], q_dull_type: ["no_glow"], q_dull_sensitive: ["yes"] }, expect: (d) => d.patterns.includes("simplicity_over_more") && ["SENSITIVITY", "BARRIER"].includes(d.priority_need) && !d.recommendations.some((r) => r.product.primary_needs.RADIANCE || r.product.primary_needs.TONE) },
    { name: "Eye contour", answers: { q1: ["lines"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["age"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_age_support: ["lines"], q_eye: ["yes"], q_age_skin: ["comfortable"], q_actives: ["no"] }, expect: (d) => d.recommendations.some((r) => r.product.product_role === "EYE_CARE") },
    { name: "No hidden assumptions", answers: { q1: ["lines"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["age"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_age_support: ["lines"], q_eye: ["no"], q_age_skin: ["comfortable"], q_actives: ["no"] }, expect: (d) => !JSON.stringify(d.result).match(/leeftijd|menopauze|huidtype/i) },
    { name: "Sensilis Barrier in stock", answers: { q1: ["redness"], q_change: ["same"], q2: ["sensitive"], q2a: ["foam_gel"], q2b: ["sensitive"], q3: ["sensitive_red"], q4: ["calm", "barrier"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_sens_how: ["stings", "fragile"], q_sens_freq: ["daily"], q_red_duration: ["hours"] }, expect: (d) => d.recommendations.some((r) => r.product.product_id === "sensilis-barrier" && r.inventory.status === "available" && !r.inventory.replaces) },
    { name: "No clear need", answers: { q1: ["nothing"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["simple"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"] }, expect: (d) => d.result.noClearNeed && d.recommendations.length === 0 && d.protect_decision.type === "check" },
    { name: "Relevant selling", answers: { q1: ["dry", "pigment"], q_change: ["same"], q2: ["dry_tight"], q2a: ["cream_milk"], q2b: ["still_dry"], q3: ["drier"], q4: ["hydration", "tone"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_pigment_type: ["sun_spots"], q_pigment_since: ["longer"], q_pigment_spf: ["daily"] }, expect: (d) => d.recommendations.length >= 2 && d.recommendations.some((r) => r.product.primary_needs.TONE) },
    { name: "Daily SPF + too many layers", answers: { q1: ["dry"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["hydration", "simple"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["few_layers", "light"], q6c: ["cream_plus_spf"] }, expect: (d) => d.protect_decision.type === "check" && !d.protect_decision.daily_base_spf && renderProtect(d.protect_decision).includes("Protect? Check.") },
    { name: "Daily SPF works well", answers: { q1: ["nothing"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["simple"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"] }, expect: (d) => d.protect_decision.type === "check" },
    { name: "Semantic duplicate routing", answers: { q1: ["blemishes", "pigment"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["clarity", "tone"], q5: ["cleanser_cream"], q6: ["sunny"], q6a: ["morning"], q6b: ["none"], q_blemish_type: ["occasional"], q_blemish_where: ["tzone"], q_pigment_type: ["sun_spots"], q_pigment_since: ["longer"] }, expect: (d) => !visibleQuestionIds(d.answers).includes("q_blemish_freq") && !visibleQuestionIds(d.answers).includes("q_pigment_spf") && d.canonical_facts.blemish_frequency === "occasional" && d.canonical_facts.spf_frequency === "sunny" },
    { name: "Reapplication SPF add-on", answers: { q1: ["nothing"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["simple"], q5: ["cleanser_cream"], q6: ["sunny"], q6a: ["morning", "hard"], q6b: ["light"] }, expect: (d) => d.protect_decision.daily_base_spf?.product.product_role === "DAILY_SPF" && d.protect_decision.reapplication_spf?.product.product_role === "SPF_REAPPLICATION" && renderProtect(d.protect_decision).includes("Deze vorm maakt opnieuw aanbrengen makkelijker") },
    { name: "Second product explanation uses additional need", answers: { q1: ["dry", "pigment"], q_change: ["same"], q2: ["dry_tight"], q2a: ["cream_milk"], q2b: ["still_dry"], q3: ["drier"], q4: ["hydration", "tone"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_pigment_type: ["sun_spots"], q_pigment_since: ["longer"], q_pigment_spf: ["daily"] }, expect: (d) => d.result.blocks.length >= 2 && d.result.blocks[1].reason !== d.result.blocks[0].reason && /serum|moisturizer|crème|teint|glow/.test(d.result.blocks[1].reason) && !/Je gaf ook aan|Waar de eerste keuze|Daarom legt LOLA/.test(d.result.blocks[1].reason) },
    { name: "Third product requires a standalone reason", answers: { q1: ["lines"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["age"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_age_support: ["lines"], q_eye: ["yes"], q_age_skin: ["comfortable"], q_actives: ["no"] }, expect: (d) => d.result.blocks.length === 2 && d.recommendations.some((r) => r.product.product_role === "EYE_CARE") },
    { name: "CAUTION_LOW does not show result safety note", answers: { q1: ["redness"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["calm"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_sens_how: ["red"], q_sens_freq: ["sometimes"], q_red_duration: ["hours"] }, expect: (d) => d.safety_flags.includes("CAUTION_LOW") && !d.result.safetyNote },
    { name: "TONE secondary can beat another primary add-on", answers: { q1: ["lines", "pigment"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["age", "tone"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_pigment_type: ["sun_spots"], q_pigment_since: ["longer"], q_pigment_spf: ["daily"], q_age_support: ["lines", "firmness"], q_eye: ["no"], q_age_skin: ["comfortable"], q_actives: ["no"] }, expect: (d) => d.recommendations[0]?.assigned_need === "AGE_SUPPORT" && d.recommendations[1]?.assigned_need === "TONE" && d.recommendations[1]?.product.product_id === "cb-sophia" },
    { name: "Actives context avoids extra active stacking", answers: { q1: ["lines", "pigment"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["age", "tone"], q5: ["many_actives"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_pigment_type: ["sun_spots"], q_pigment_since: ["longer"], q_pigment_spf: ["daily"], q_age_support: ["lines", "firmness"], q_eye: ["yes"], q_age_skin: ["comfortable"], q_actives: ["regular"] }, expect: (d) => d.patterns.includes("active_routine_context") && d.routine_context.active_user && d.routine_context.active_ingredients === "regular" && !d.recommendations.some((r) => r.assigned_need === "TONE" && r.product.product_role === "SERUM") },
    { name: "Eye product only after explicit eye contour", answers: { q1: ["lines"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["age"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_age_support: ["lines"], q_eye: ["no"], q_age_skin: ["comfortable"], q_actives: ["no"] }, expect: (d) => !d.recommendations.some((r) => r.product.product_role === "EYE_CARE") && d.filtered_products.some((p) => p.reasons.includes("oogcontour niet expliciet geselecteerd")) },
    { name: "Customer copy hides internal eligibility logic", answers: { q1: ["lines"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["age"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_age_support: ["lines"], q_eye: ["yes"], q_age_skin: ["comfortable"], q_actives: ["no"] }, expect: (d) => !/alleen als|alleen wanneer|eligib|productrol|ranking|branch|score/i.test(d.result.blocks.map((b) => b.reason).join(" ")) },
    { name: "Relevant explicit answers are traceable", answers: { q1: ["lines", "pigment"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["age", "tone"], q5: ["many_actives"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_pigment_type: ["sun_spots"], q_pigment_since: ["longer"], q_pigment_spf: ["daily"], q_age_support: ["lines", "firmness"], q_eye: ["yes"], q_age_skin: ["comfortable"], q_actives: ["regular"] }, expect: (d) => ["q1:pigment", "q4:tone", "q_pigment_type:sun_spots", "q_pigment_since:longer", "q5:many_actives", "q_actives:regular", "q_eye:yes"].every((key) => { const [question_id, answer_id] = key.split(":"); return d.answer_traceability.some((trace) => trace.question_id === question_id && trace.answer_id === answer_id && trace.effects.length > 0); }) },
    { name: "AGE + eye contour + strong TONE can produce three distinct reasons", answers: { q1: ["lines", "pigment"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["age", "tone"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_pigment_type: ["sun_spots"], q_pigment_since: ["longer"], q_pigment_spf: ["daily"], q_age_support: ["lines", "firmness"], q_eye: ["yes"], q_age_skin: ["comfortable"], q_actives: ["no"] }, expect: (d) => d.recommendations.length === 3 && d.recommendations.map((r) => r.assigned_need).join("|") === "AGE_SUPPORT|EYE_CONTOUR|TONE" && d.result.blocks.map((b) => b.heading).join("|") === "Begin hiermee|Combineer met|Als extra stap" && new Set(d.result.blocks.map((b) => b.reason)).size === 3 && d.result.blocks.some((b) => /pigmentvlekjes|ongelijkmatige teint|meer glow/.test(b.reason)) },
    { name: "Weak pigment signal does not force extra product", answers: { q1: ["lines", "pigment"], q_change: ["same"], q2: ["comfortable"], q3: ["comfortable"], q4: ["age"], q5: ["cleanser_cream"], q6: ["daily"], q6a: ["morning"], q6b: ["none"], q6c: ["spf_replaces_cream"], q_pigment_type: ["general"], q_pigment_since: ["unknown"], q_pigment_spf: ["daily"], q_age_support: ["lines"], q_eye: ["yes"], q_age_skin: ["comfortable"], q_actives: ["no"] }, expect: (d) => d.need_scores_after_context.TONE === 3 && !d.recommendations.some((r) => r.assigned_need === "TONE") && d.answer_traceability.some((trace) => trace.question_id === "q1" && trace.answer_id === "pigment" && trace.effects.some((effect) => effect.includes("not recommended"))) },
  ];
}

enrichProductsWithShopifyData();
render();
